// openindex.js — OpenDraw (Premium) ✅ UPDATED
// Includes:
// - Select button next to Undo
// - Icons stamping (from /icons)
// - Arrows panel (arrow.svg, screen.svg)
// - Arrow draw by drag (paint-like), harmonized to line/quad/cubic (max 2 control points)
// - Dashed/intercalated arrow tool (same head image)
// - NEW: Dribble arrow tool (wavy line + solid head)
// - Arrows selectable + movable + deletable
// - Anything selected shows a mini "X" badge (click to delete)
// - Export to PDF (title + frames) in grid: 2 columns x 3 rows per page (max 6 frames)
// - NEW: Zoom +/- buttons (optional, if present in HTML)
// Notes:
// - Expects: court.svg, /icons/*.svg, arrow.svg, screen.svg
// - Frames keep ratio; zoom scales the canvases
import { initTopbar } from "./od_topbar.js";
import { startTour } from "./od_tour.js";
import { t, applyTranslations } from "./od_i18n.js";
import { initAnimation } from "./od_animation.js";
import { showAnimationAnnouncement, openRequestedAnimation } from "./od_animation_announcement.js";
import { recordAnimationExport } from "./od_animation_metrics.js";

function getEditorTourSteps() {
  return [
    { target: '.toolList',     text: t('tour_ed_1'), position: 'right'  },
    { target: '#smartFrameBtn',text: t('tour_ed_2'), position: 'top'    },
    { target: '#exportPdfBtn', text: t('tour_ed_3'), position: 'bottom' },
    { target: '#newPlayBtn',   text: t('tour_ed_4'), position: 'bottom' },
    { target: '.editorNavBar', text: t('tour_ed_5'), position: 'bottom' },
  ];
}
import {
  setRendererPaths,
  ensureAssetsLoaded,
  renderFrameToCanvas,
  frameHasContent as frameHasContentRenderer
} from "./od_renderer.js";

const COURT_IMG_SRC = "./courtEditor.svg";
const OD_TEMPLATE_ADMIN_EMAIL = "imahernandez1@gmail.com";
const OD_TEMPLATE_MODE = new URLSearchParams(window.location.search || "").get("templateAdmin") === "1";


// ICONS (includes 1c.svg)
const ICON_FILES = [
  "1.svg","2.svg",
  "3.svg","4.svg",
  "5.svg","1c.svg",
  "2c.svg","3c.svg",
  "4c.svg","5c.svg",
  "x1.svg","x2.svg","x3.svg","x4.svg","x5.svg",
  "coach.svg",
"dho.svg",
];
const ICON_BASE_PATH = "./icons/";

// ARROWHEADS (tips)
const ARROWHEAD_FILES = ["arrow.svg","screen.svg"];
const ARROWHEAD_BASE_PATH = "./";

// Frames 75% of 700x650
const FRAME_W = 525;
const FRAME_H = 488;

// NEW: icons inside frames look 50% bigger (render + hit-test + selection box)
const ICON_RENDER_SCALE = 1.8;

const state = {
  tool: "select",          // select | arrow | arrowDash | dribble | text | delete
  strokeWidth: 3,
  gridOn: false,
  snapOn: true,
  zoom: 1.0,
color: "#000000",

  isExporting: false,
courtMode: "set",   // "set" | "ob"
courtScale: 0.83,   // escala para OB




  frames: [],
  selectedFrameId: null,

  selectedIcon: "null",   // stamping mode when not null
  selectedArrowhead: "arrow.svg",

  selectedObjectId: null,
    lineMode: "curve", // "curve" | "straight"

};
const EditorCache = {
  loadedTeamId: null,
  loadedSeasonId: null,
  teams: [],
  seasons: [],
  plays: []
};
const $ = (s) => document.querySelector(s);
const $$ = (s) => Array.from(document.querySelectorAll(s));

const framesGrid = $("#framesGrid");
const statusLeft = $("#statusLeft");
const statusRight = $("#statusRight");

const strokeWidth = $("#strokeWidth");
const strokeWidthVal = $("#strokeWidthVal");
const gridToggle = $("#gridToggle");
const snapOnEl = $("#snapOn");
const zoomSel = $("#zoomSel");

const addFrameBtn = $("#addFrameBtn");
const smartFrameBtn = $("#smartFrameBtn");
const dupFrameBtn = $("#dupFrameBtn");
const clearFrameBtn = $("#clearFrameBtn");
const smartFramePillBtn = $("#smartFramePillBtn");


const undoBtn = $("#undoBtn");
const iconGrid = $("#iconGrid");

// Optional buttons (only work if you add them to HTML)
const zoomInBtn = $("#zoomInBtn");
const zoomOutBtn = $("#zoomOutBtn");

let arrowGridEl = null;
let selectArrowBtn = null;
let currentTeamId = null;
let currentSeasonId = null;
let currentPlayId = null;


// ---------- Utils
let od_autosaveQueued = false;
function clampFrameIntoCourt(frame){
  if(!frame || !Array.isArray(frame.objects)) return;

  const clamp01 = (v) => Math.max(0, Math.min(1, v));
  const clampTo = (v, lo, hi) => Math.max(lo, Math.min(hi, v));

  for(const o of frame.objects){

    // ICONS: clamp con margen según tamaño (para que no quede cortado)
    if(o.type === "icon"){
      // o.w / o.h están normalizados (0..1 del court), por eso el margen es su mitad
      const halfX = (o.w || 0) * 0.5;
      const halfY = (o.h || 0) * 0.5;

      const minX = halfX;
      const maxX = 1 - halfX;
      const minY = halfY;
      const maxY = 1 - halfY;

      o.x = clampTo(o.x, minX, maxX);
      o.y = clampTo(o.y, minY, maxY);
      continue;
    }

    // TEXT: clamp simple (si querés permitir texto pegado al borde, dejalo así)
    if(o.type === "text"){
      o.x = clamp01(o.x);
      o.y = clamp01(o.y);
      continue;
    }

    // ARROWS: clamp de puntos normalizados
    if(o.type === "arrow" && o.curve){
      const c = o.curve;

      const clampPt = (pt) => {
        if(!pt) return pt;
        return { ...pt, x: clamp01(pt.x), y: clamp01(pt.y) };
      };

      if(c.type === "line"){
        o.curve = { ...c, a: clampPt(c.a), b: clampPt(c.b) };
      } else if(c.type === "quad"){
        o.curve = { ...c, a: clampPt(c.a), c1: clampPt(c.c1), b: clampPt(c.b) };
      }
      continue;
    }
  }
}

function clampAllFramesIntoCourt(){
  for(const fr of state.frames) clampFrameIntoCourt(fr);
}


function odScheduleAutosave(){
  if (OD_TEMPLATE_MODE) return;
  if (od_autosaveTimer) clearTimeout(od_autosaveTimer);
  od_autosaveTimer = setTimeout(odRunAutosave, 650);
}

// === AUTOSAVE (frames only) ===
let od_autosaveTimer = null;
let od_autosaveInFlight = false;
let od_autosaveDirty = false;

async function odAutosave(reason = "Edited"){
  if (OD_TEMPLATE_MODE) return;
  if (od_autosaveTimer) clearTimeout(od_autosaveTimer);

  if (statusLeft) statusLeft.textContent = `${reason} •`;

  od_autosaveTimer = setTimeout(async () => {
    if (od_autosaveInFlight) return;
    if (typeof od_isSwitchingContext !== "undefined" && od_isSwitchingContext) return;

    // 🔒 ÚNICA FUENTE DE VERDAD
    const playId = window.od_activePlayId;
    if (!playId) return;

    od_autosaveInFlight = true;
    if (statusLeft) statusLeft.textContent = "Saving…";

    try{
      const auth = await odEnsureAuthedOrRedirect();
      if (!auth.ok) return;

      const odplayObj = odBuildOdplay();
      const hasContent = odHasRealContent(odplayObj);

      const payload = {
        odplayV: ODPLAY_VERSION,
        odplayJson: JSON.stringify(odplayObj),
        hasContent,
        status: hasContent ? "active" : "draft",
        updatedAt: new Date()
      };

      const db = window.firebase.firestore();
      await db
        .collection("users")
        .doc(auth.user.uid)
        .collection("plays")
        .doc(playId)
        .set(payload, { merge: true });

      if (statusLeft) statusLeft.textContent = "Saved ✓";
const el = document.getElementById("statusLeft");
if(el){
  el.classList.remove("odSavedPulse");
  void el.offsetWidth; // reflow
  el.classList.add("odSavedPulse");
}

    } catch (e){
      if (statusLeft) statusLeft.textContent = "Save failed (console)";
    } finally {
      od_autosaveInFlight = false;
    }
  }, 650);
}



function uid(){ return Math.random().toString(16).slice(2) + Date.now().toString(16); }
function clamp(v,min,max){ return Math.max(min, Math.min(max, v)); }


function setStatus(l,r){
  if(statusLeft && l!=null) statusLeft.textContent = l;
  if(statusRight && r!=null) statusRight.textContent = r;
}
function odPulseSaved(){
  const el = document.getElementById("statusLeft");
  if(!el) return;

  el.classList.remove("odSavedPulse");
  void el.offsetWidth;           // fuerza reflow para repetir animación
  el.classList.add("odSavedPulse");
}



function isTypingInField(){
  const el = document.activeElement;
  if(!el) return false;
  const tag = (el.tagName||"").toLowerCase();
  return tag === "input" || tag === "textarea" || el.isContentEditable;
}

function titleCaseTool(t){
  if(!t) return "";
  return t[0].toUpperCase() + t.slice(1);
}
function setColor(hex){
  state.color = hex;

  // UI
  const row = document.getElementById("colorRow");
  if(row){
    row.querySelectorAll(".colorSwatch").forEach(b=>{
      b.classList.toggle("active", b.dataset.color === hex);
    });
  }

  // Apply to selected object (if any)
  applyColorToSelected(hex);

  setStatus(`Color: ${hex}`, null);
}

function applyColorToSelected(hex){
  const f = getSelectedFrame?.();
  if(!f || !state.selectedObjectId) return;

  const o = f.objects.find(x => x && x.id === state.selectedObjectId);
  if(!o) return;

  // Guardar color en el objeto
  o.color = hex;

  snapshotFrame(f);
  renderAll();
}

function setTool(t){
  state.tool = t;
  $$(".toolItem").forEach(b => b.classList.toggle("active", b.dataset.tool === t));
  if(selectArrowBtn) selectArrowBtn.classList.toggle("active", t === "select");
  setStatus(null, `Tool: ${titleCaseTool(t)}`);
}

function setSelectedIcon(filename){
  state.selectedIcon = filename;
  $$(".iconBtn").forEach(b=>{
    if(b.dataset.icon) b.classList.toggle("active", b.dataset.icon === filename);
  });
  setStatus(`Icon: ${filename}`, "Stamp: click inside a frame");
}

function setSelectedArrowhead(filename){
  state.selectedArrowhead = filename;
  if(arrowGridEl){
    arrowGridEl.querySelectorAll(".iconBtn").forEach(b=>{
      b.classList.toggle("active", b.dataset.arrowhead === filename);
    });
  }
  setStatus(`Arrowhead: ${filename}`, "Arrow: click + drag, release to place head");
}
function forceCurveToStraight(curvePx){
  if(!curvePx) return null;
  return {
    type: "line",
    a: { x: curvePx.a.x, y: curvePx.a.y },
    b: { x: curvePx.b.x, y: curvePx.b.y }, // tu b es el NECK (mouse)
  };
}

function setLineMode(mode){
  state.lineMode = (mode === "straight") ? "straight" : "curve";
  try{ localStorage.setItem("od_lineMode", state.lineMode); }catch{}

  const bCurve = document.getElementById("modeCurveBtn");
  const bStraight = document.getElementById("modeStraightBtn");
  const sw = document.getElementById("pathSwitch");

  if(bCurve)   bCurve.classList.toggle("active", state.lineMode === "curve");
  if(bStraight) bStraight.classList.toggle("active", state.lineMode === "straight");

  if(bCurve)   bCurve.setAttribute("aria-selected", String(state.lineMode === "curve"));
  if(bStraight) bStraight.setAttribute("aria-selected", String(state.lineMode === "straight"));

  if(sw) sw.classList.toggle("isStraight", state.lineMode === "straight");

  setStatus(`Path: ${state.lineMode}`, null);
}

(function wireColorPanel(){
  const row = document.getElementById("colorRow");
  if(!row) return;

  row.querySelectorAll(".colorSwatch").forEach(b=>{
    // pintar el swatch con su color
    b.style.background = b.dataset.color;

    if(!b._wired){
      b._wired = true;
      b.addEventListener("click", (e)=>{
        e.preventDefault();
        e.stopPropagation();
        setColor(b.dataset.color);
      });
    }
  });
})();


function drawLineModeIcons(){
  const drawCurve = (cv)=>{
    const ctx = cv.getContext("2d");
    const w = cv.width, h = cv.height;
    ctx.clearRect(0,0,w,h);
    ctx.lineWidth = 3;
    ctx.lineCap = "round";
    ctx.strokeStyle = "rgba(255,255,255,0.92)";
    ctx.beginPath();
    ctx.moveTo(4, h-5);
    ctx.quadraticCurveTo(w*0.55, 2, w-4, h-6);
    ctx.stroke();
  };

  const drawStraight = (cv)=>{
    const ctx = cv.getContext("2d");
    const w = cv.width, h = cv.height;
    ctx.clearRect(0,0,w,h);
    ctx.lineWidth = 3;
    ctx.lineCap = "round";
    ctx.strokeStyle = "rgba(255,255,255,0.92)";
    ctx.beginPath();
    ctx.moveTo(4, h/2);
    ctx.lineTo(w-4, h/2);
    ctx.stroke();
  };

  const c1 = document.getElementById("modeCurveCv");
  const c2 = document.getElementById("modeStraightCv");
  if(c1) drawCurve(c1);
  if(c2) drawStraight(c2);
}
let od_isSwitchingContext = false;

function ensureLineModePanel(){
  // Si no existe el panel en HTML, no hacemos nada
  const panel = document.getElementById("lineModePanel");
  if(!panel) return;

  // Cargar preferencia
  try{
    const saved = localStorage.getItem("od_lineMode");
    if(saved === "straight" || saved === "curve") state.lineMode = saved;
    else state.lineMode = "curve";
  }catch{
    state.lineMode = "curve";
  }

  const bCurve = document.getElementById("modeCurveBtn");
  const bStraight = document.getElementById("modeStraightBtn");

  if(bCurve && !bCurve._wired){
    bCurve._wired = true;
    bCurve.addEventListener("click", (e)=>{
      e.preventDefault();
      e.stopPropagation();
      setLineMode("curve");
    });
  }

  if(bStraight && !bStraight._wired){
    bStraight._wired = true;
    bStraight.addEventListener("click", (e)=>{
      e.preventDefault();
      e.stopPropagation();
      setLineMode("straight");
    });
  }

  drawLineModeIcons();
  setLineMode(state.lineMode); // pinta activo + mueve switch
}




// aspect = imgW/imgH
function heightNormFromWidthNorm(wNorm, aspect, canvasW, canvasH){
  return (wNorm * canvasW) / (aspect * canvasH);
}
function pxToNorm(px,py,w,h){ return {x:px/w, y:py/h}; }
function normToPx(nx,ny,w,h){ return {x:nx*w, y:ny*h}; }

// ---------- Frame model + history
function newFrame(label){
  return { id: uid(), label, desc:"", objects:[], history:[], historyIdx:-1 };
}

function snapshotFrame(frame){
  const snap = JSON.stringify(frame.objects);
  frame.history = frame.history.slice(0, frame.historyIdx+1);
  frame.history.push(snap);
  frame.historyIdx++;
odAutosave("Frame");

}

function undoFrame(frame){
  if(frame.historyIdx <= 0) return;
  frame.historyIdx--;
  frame.objects = JSON.parse(frame.history[frame.historyIdx]);
  state.selectedObjectId = null;
}

function clearFrame(frame){
  frame.objects = [];
  snapshotFrame(frame);
  state.selectedObjectId = null;
}

function duplicateFrame(src){
  const f = newFrame(src.label + " copy");
  f.desc = src.desc;
  f.objects = JSON.parse(JSON.stringify(src.objects));
  snapshotFrame(f);
  return f;
}
// ---------- Smart Frame
const SMART_ICON_SET = new Set([
  "1.svg","1c.svg",
  "2.svg","2c.svg",
  "3.svg","3c.svg",
  "4.svg","4c.svg",
  "5.svg","5c.svg",
  "x1.svg","x2.svg","x3.svg","x4.svg","x5.svg",
]);

function distPx(ax, ay, bx, by){
  return Math.hypot(ax - bx, ay - by);
}

function getArrowStartPx(arrow, w, h){
  const a = arrow?.curve?.a;
  if(!a) return null;
  return { x: a.x * w, y: a.y * h };
}

function getArrowEndNorm(arrow){
  // En tu modelo, curve.b es el final “real” (NECK / mouse up)
  // y es lo más consistente para “a dónde manda la jugada”.
  const b = arrow?.curve?.b;
  if(!b) return null;
  return { x: b.x, y: b.y };
}

function buildSmartFrameFrom(srcFrame){
  const f = newFrame(srcFrame.label || "Frame");
  f.desc = srcFrame.desc || "";

  // Usá una métrica estable (no dependiente del zoom del UI)
  const w = Math.round(FRAME_W);
  const h = Math.round(FRAME_H);

  const srcObjects = (srcFrame.objects || []);

  // ✅ SOLO jugadores
  const players = srcObjects.filter(o =>
    o && o.type === "icon" && SMART_ICON_SET.has(o.icon)
  );

 const arrows = srcObjects.filter(o =>
  o &&
  o.type === "arrow" &&
  o.curve && o.curve.a && o.curve.b &&
  (o.style || "solid") !== "dash"   // ✅ ignorar pases
);


  // ✅ “cerca” más grande (ajustable)
  const NEAR_PX = 70;   // antes ~34
  const MAX_PX  = 120;  // fallback más permisivo

  const movedPlayers = players.map(ic => {
    const out = JSON.parse(JSON.stringify(ic));

    const icPx = { x: ic.x * w, y: ic.y * h };

    let bestArrow = null;
    let bestD = Infinity;

    // flecha cuya START (a) está más cerca del jugador
    for(const ar of arrows){
      const a = ar.curve.a;
      const aPx = { x: a.x * w, y: a.y * h };
      const d = distPx(icPx.x, icPx.y, aPx.x, aPx.y);

      if(d < bestD){
        bestD = d;
        bestArrow = ar;
      }
    }

    // si está “cerca”, mover al END (b)
    if(bestArrow && bestD <= MAX_PX){
      const tip = getArrowHeadTipNorm(bestArrow, w, h);
if(tip){
  out.x = tip.x;
  out.y = tip.y;
}

    }

    return out;
  });

  // ✅ SOLO jugadores en el frame nuevo
  f.objects = movedPlayers;
  return f;
}
function getArrowHeadTipNorm(arrow, w, h){
  if(!arrow || arrow.type !== "arrow" || !arrow.curve || !arrow.curve.b) return null;

  // curva a px para derivada/tangente
  const curvePx = normalizeCurveToPx(arrow.curve, w, h);

  // dirección final: dribble usa dirAng congelado, si no derivada al final
  let ux = 1, uy = 0;

  if (typeof arrow.dirAng === "number" && isFinite(arrow.dirAng)) {
    ux = Math.cos(arrow.dirAng);
    uy = Math.sin(arrow.dirAng);
  } else {
    let dx = 1, dy = 0;
    if(curvePx.type === "line"){
      dx = curvePx.b.x - curvePx.a.x;
      dy = curvePx.b.y - curvePx.a.y;
    } else if(curvePx.type === "quad"){
      dx = 2 * (curvePx.b.x - curvePx.c1.x);
      dy = 2 * (curvePx.b.y - curvePx.c1.y);
    } else {
      dx = 3 * (curvePx.b.x - curvePx.c2.x);
      dy = 3 * (curvePx.b.y - curvePx.c2.y);
    }
    const len = Math.hypot(dx, dy) || 1;
    ux = dx / len;
    uy = dy / len;
  }

  // mismo sizing que drawArrow (para que coincida con lo que ves)
  const headBase = 22;
  const headSize = (headBase + state.strokeWidth * 2) * state.zoom;
  const cut = headSize * 0.98;
  const headPush = Math.max(1.5, headSize * 0.06);

  const bx = curvePx.b.x, by = curvePx.b.y;
  const headType = arrow.head || "arrow";

  // tip real
  const adv = (headType === "screen") ? headPush : (cut + headPush);
  const tipPxX = bx + ux * adv;
  const tipPxY = by + uy * adv;

  // volver a norm
  return {
    x: clamp(tipPxX / w, 0, 1),
    y: clamp(tipPxY / h, 0, 1),
  };
}


// ---------- Assets
function setCourtMode(mode){
  const next = (mode === "ob") ? "ob" : "set";

  // ✅ si apaga OB, clamp dentro del court (tu regla nueva)
  if(state.courtMode === "ob" && next === "set"){
    clampAllFramesIntoCourt();
    state.selectedObjectId = null; // opcional: evita selección afuera
  }

  state.courtMode = next;

  // ✅ esto ahora ES parte de la jugada: guardalo
  odAutosave("Court mode");

  renderAll();
}




async function loadImg(src){
  return new Promise((res, rej)=>{
    const img = new Image();
    // Helps when assets are served with CORS (and doesn’t hurt same-origin hosting)
    img.crossOrigin = "anonymous";
    img.onload = ()=>res(img);
    img.onerror = rej;
    img.src = src;
  });
}

async function loadBrandLogoDataUrl(){
  try {
    const img = await loadImg("./favicon.png");
    const canvas = document.createElement("canvas");
    canvas.width = img.naturalWidth || 256;
    canvas.height = img.naturalHeight || 256;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    return canvas.toDataURL("image/png");
  } catch {
    return null;
  }
}

let COURT_IMG = null;
const ICON_CACHE = new Map();      // filename -> Image
const ARROWHEAD_CACHE = new Map(); // filename -> Image


async function preloadIcons(){
  await Promise.all(ICON_FILES.map(async f=>{
    try{ ICON_CACHE.set(f, await loadImg(ICON_BASE_PATH + f)); }
    catch{ }
  }));
}
const TINT_CACHE = new Map(); // key: icon|color -> offscreen canvas
function getTintedIconCanvas(img, hex){
  const key = (img?.src || "img") + "|" + hex;
  if(TINT_CACHE.has(key)) return TINT_CACHE.get(key);

  const w = img.naturalWidth || 64;
  const h = img.naturalHeight || 64;

  const c = document.createElement("canvas");
  c.width = w; c.height = h;
  const cx = c.getContext("2d");

  // draw original
  cx.clearRect(0,0,w,h);
  cx.drawImage(img, 0, 0, w, h);

  // tint using source-in
  cx.globalCompositeOperation = "source-in";
  cx.fillStyle = hex;
  cx.fillRect(0,0,w,h);

  cx.globalCompositeOperation = "source-over";

  TINT_CACHE.set(key, c);
  return c;
}

async function preloadArrowheads(){
  await Promise.all(ARROWHEAD_FILES.map(async f=>{
    try{ ARROWHEAD_CACHE.set(f, await loadImg(ARROWHEAD_BASE_PATH + f)); }
    catch{  }
  }));
}

// ---------- Grid / snap
function drawGrid(ctx,w,h){
  if(!state.gridOn) return;
  const step = Math.max(2, Math.round(4 * state.zoom));

  ctx.save();
  ctx.globalAlpha = 0.08;
  ctx.lineWidth = 1;
  ctx.strokeStyle = "#000";
  for(let x=0;x<w;x+=step){ ctx.beginPath(); ctx.moveTo(x,0); ctx.lineTo(x,h); ctx.stroke(); }
  for(let y=0;y<h;y+=step){ ctx.beginPath(); ctx.moveTo(0,y); ctx.lineTo(w,y); ctx.stroke(); }
  ctx.restore();
}

function snapPx(x,y,w,h){
  if(!state.snapOn) return {x,y};
  const step = Math.max(2, 3 * state.zoom);
  const sx = Math.round(x/step)*step;
  const sy = Math.round(y/step)*step;
  return { x: clamp(sx,0,w), y: clamp(sy,0,h) };
}


// ---------- Dribble direction (RAW drag) — keep head/hook pointing where the mouse actually ended
function finalAngleFromRawStroke(rawPts, zoom){
  if(!rawPts || rawPts.length < 2) return null;

  const last = rawPts[rawPts.length - 1];
  const minDist = Math.max(10, 16 * zoom);

  // Walk backwards until we find a point far enough to stabilize the direction
  let acc = 0;
  for(let i = rawPts.length - 2; i >= 0; i--){
    const p = rawPts[i];
    const dx = last.x - p.x;
    const dy = last.y - p.y;
    const d = Math.hypot(dx, dy);

    // Prefer a single segment that reaches the threshold
    if(d >= minDist){
      return Math.atan2(dy, dx);
    }

    // Otherwise accumulate distance to avoid micro-wiggles near the end
    acc += Math.hypot(rawPts[i+1].x - p.x, rawPts[i+1].y - p.y);
    if(acc >= minDist){
      return Math.atan2(dy, dx);
    }
  }

  // Fallback: last segment
  const p0 = rawPts[0];
  return Math.atan2(last.y - p0.y, last.x - p0.x);
}
// ---------- Curve harmonizer (max 2 control points)
function decimatePoints(points, minDistPx=6){
  if(points.length <= 2) return points;
  const out = [points[0]];
  let last = points[0];
  for(let i=1;i<points.length-1;i++){
    const p = points[i];
    const d = Math.hypot(p.x-last.x, p.y-last.y);
    if(d >= minDistPx){ out.push(p); last = p; }
  }
  out.push(points[points.length-1]);
  return out;
}

function maxDeviation(points){
  if(points.length < 3) return 0;
  const a=points[0], b=points[points.length-1];
  const vx=b.x-a.x, vy=b.y-a.y;
  const len = Math.hypot(vx,vy) || 1;
  const nx=-vy/len, ny=vx/len;
  let m=0;
  for(let i=1;i<points.length-1;i++){
    const p=points[i];
    const dx=p.x-a.x, dy=p.y-a.y;
    const dev = Math.abs(dx*nx + dy*ny);
    if(dev > m) m = dev;
  }
  return m;
}

function fitQuadratic(points){
  const a=points[0], b=points[points.length-1];
  let best=points[Math.floor(points.length/2)];
  let bestDev=-1;
  const vx=b.x-a.x, vy=b.y-a.y;
  const len = Math.hypot(vx,vy) || 1;
  const nx=-vy/len, ny=vx/len;
  for(let i=1;i<points.length-1;i++){
    const p=points[i];
    const dx=p.x-a.x, dy=p.y-a.y;
    const dev = Math.abs(dx*nx + dy*ny);
    if(dev > bestDev){ bestDev = dev; best = p; }
  }
  return { type:"quad", a, c1:best, b };
}

function fitCubic(points){
  const a=points[0], b=points[points.length-1];
  const i1=Math.floor(points.length/3);
  const i2=Math.floor((points.length*2)/3);
  return { type:"cubic", a, c1:points[i1], c2:points[i2], b };
}

function harmonizeStroke(points){
  const pts = decimatePoints(points, 6);
  if(pts.length < 2) return null;
  if(pts.length === 2) return { type:"line", a:pts[0], b:pts[1] };

  const dev = maxDeviation(pts);
  const chord = Math.hypot(pts.at(-1).x-pts[0].x, pts.at(-1).y-pts[0].y) || 1;
  const ratio = dev / chord;

  // recta o curva simple (QUAD). Nunca cubic.
  if(ratio < 0.10) return { type:"line", a:pts[0], b:pts.at(-1) };

  return fitQuadratic(pts);
}


function evalQuad(a,c1,b,t){
  const u=1-t;
  return { x:u*u*a.x + 2*u*t*c1.x + t*t*b.x, y:u*u*a.y + 2*u*t*c1.y + t*t*b.y };
}

function evalCubic(a,c1,c2,b,t){
  const u=1-t;
  return {
    x:u*u*u*a.x + 3*u*u*t*c1.x + 3*u*t*t*c2.x + t*t*t*b.x,
    y:u*u*u*a.y + 3*u*u*t*c1.y + 3*u*t*t*c2.y + t*t*t*b.y
  };
}

// Calcula el ángulo de la tangente al final de una curva normalizada
function getFinalTangentAngle(curveNorm){
  if(!curveNorm) return 0;
  
  let dx = 1, dy = 0;
  
  if(curveNorm.type === "line"){
    dx = curveNorm.b.x - curveNorm.a.x;
    dy = curveNorm.b.y - curveNorm.a.y;
  } else if(curveNorm.type === "quad"){
    // Tangente al final de una curva cuadrática: 2*(b - c1)
    dx = 2 * (curveNorm.b.x - curveNorm.c1.x);
    dy = 2 * (curveNorm.b.y - curveNorm.c1.y);
  } else if(curveNorm.type === "cubic"){
    // Tangente al final de una curva cúbica: 3*(b - c2)
    dx = 3 * (curveNorm.b.x - curveNorm.c2.x);
    dy = 3 * (curveNorm.b.y - curveNorm.c2.y);
  }
  
  return Math.atan2(dy, dx);
}
function resamplePolylineByStep(points, stepPx) {
  if (!points || points.length < 2) return points || [];

  const out = [points[0]];
  let acc = 0;

  for (let i = 1; i < points.length; i++) {
    let p0 = points[i - 1];
    const p1 = points[i];

    let segDx = p1.x - p0.x;
    let segDy = p1.y - p0.y;
    let segLen = Math.hypot(segDx, segDy);

    if (segLen === 0) continue;

    while (acc + segLen >= stepPx) {
      const t = (stepPx - acc) / segLen;
      const nx = p0.x + segDx * t;
      const ny = p0.y + segDy * t;

      const np = { x: nx, y: ny };
      out.push(np);

      // continue from new point
      p0 = np;
      segDx = p1.x - p0.x;
      segDy = p1.y - p0.y;
      segLen = Math.hypot(segDx, segDy);
      acc = 0;
      if (segLen === 0) break;
    }

    acc += segLen;
  }

  // ensure last point
  const last = points[points.length - 1];
  const outLast = out[out.length - 1];
  if (!outLast || Math.hypot(last.x - outLast.x, last.y - outLast.y) > 0.01) {
    out.push(last);
  }

  return out;
}

function drawSmoothPolyline(ctx, pts) {
  if (!pts || pts.length === 0) return;
  if (pts.length === 1) {
    ctx.moveTo(pts[0].x, pts[0].y);
    return;
  }
  if (pts.length === 2) {
    ctx.moveTo(pts[0].x, pts[0].y);
    ctx.lineTo(pts[1].x, pts[1].y);
    return;
  }

  ctx.moveTo(pts[0].x, pts[0].y);

  for (let i = 1; i < pts.length - 1; i++) {
    const p = pts[i];
    const n = pts[i + 1];
    const mx = (p.x + n.x) / 2;
    const my = (p.y + n.y) / 2;
    ctx.quadraticCurveTo(p.x, p.y, mx, my);
  }

  // last segment
  const pPrev = pts[pts.length - 2];
  const pLast = pts[pts.length - 1];
  ctx.quadraticCurveTo(pPrev.x, pPrev.y, pLast.x, pLast.y);
}
function harmonicEndDirection(curvePx){
  // Muestreamos la curva como “lo que se ve”
  const pts = sampleCurvePx(curvePx, 80);
  if(!pts || pts.length < 2) return { ux: 1, uy: 0, ang: 0 };

  // Tomamos los últimos segmentos y promediamos direcciones (suaviza cambios de handler)
  const take = 8; // 6–10 va bien
  const start = Math.max(0, pts.length - 1 - take);

  let sx = 0, sy = 0, wsum = 0;

  for(let i = start; i < pts.length - 1; i++){
    const p0 = pts[i];
    const p1 = pts[i+1];
    const dx = p1.x - p0.x;
    const dy = p1.y - p0.y;
    const len = Math.hypot(dx, dy);
    if(len < 0.001) continue;

    // peso mayor cerca del final (para que el “final” mande)
    const w = (i - start + 1);
    sx += (dx / len) * w;
    sy += (dy / len) * w;
    wsum += w;
  }

  if(wsum === 0) return { ux: 1, uy: 0, ang: 0 };

  sx /= wsum; sy /= wsum;
  const n = Math.hypot(sx, sy) || 1;

  const ux = sx / n;
  const uy = sy / n;
  const ang = Math.atan2(uy, ux);

  return { ux, uy, ang };
}


function sampleCurvePx(curvePx, steps=24){
  const pts=[];
  for(let i=0;i<=steps;i++){
    const t=i/steps;
    if(curvePx.type==="line"){
      pts.push({ x:curvePx.a.x + (curvePx.b.x-curvePx.a.x)*t, y:curvePx.a.y + (curvePx.b.y-curvePx.a.y)*t });
    } else if(curvePx.type==="quad"){
      pts.push(evalQuad(curvePx.a, curvePx.c1, curvePx.b, t));
    } else {
      pts.push(evalCubic(curvePx.a, curvePx.c1, curvePx.c2, curvePx.b, t));
    }
  }
  return pts;
}


function curveToNorm(curvePx, w, h){
  const conv=(p)=>({ x:p.x/w, y:p.y/h });
  if(curvePx.type==="line") return { type:"line", a:conv(curvePx.a), b:conv(curvePx.b) };
  if(curvePx.type==="quad") return { type:"quad", a:conv(curvePx.a), c1:conv(curvePx.c1), b:conv(curvePx.b) };
  return { type:"cubic", a:conv(curvePx.a), c1:conv(curvePx.c1), c2:conv(curvePx.c2), b:conv(curvePx.b) };
}

function normalizeCurveToPx(curveNorm, w, h){
  const conv=(p)=>({ x:p.x*w, y:p.y*h });
  if(curveNorm.type==="line") return { type:"line", a:conv(curveNorm.a), b:conv(curveNorm.b) };
  if(curveNorm.type==="quad") return { type:"quad", a:conv(curveNorm.a), c1:conv(curveNorm.c1), b:conv(curveNorm.b) };
  return { type:"cubic", a:conv(curveNorm.a), c1:conv(curveNorm.c1), c2:conv(curveNorm.c2), b:conv(curveNorm.b) };
}

// ---------- Arrow draw (solid/dash/dribble + HOOK aligned to END TANGENT + head by code)
function drawArrow(ctx, curvePx, style = "solid", dirAngOverride = null, headTypeOverride = null, colorOverride = null) {
  ctx.save();
const col = colorOverride || "#000";

 const exportMul = (state.isExporting ? 3 : 1.0); // ajustá 1.3–1.6
ctx.lineWidth = state.strokeWidth * exportMul;
ctx.strokeStyle = col;
  ctx.lineCap = "round";
  ctx.lineJoin = "round";

  // dashed body (ONLY for dash)
  if (style === "dash") {
    const dash = Math.max(7, Math.round(12 * state.zoom));
    const gap  = Math.max(6, Math.round(10 * state.zoom));
    ctx.setLineDash([dash, gap]);
  } else {
    ctx.setLineDash([]);
  }

  // ---- direction at end (tangent) OR override (RAW drag for dribble)
  let ux = 1, uy = 0, ang = 0;

  if (typeof dirAngOverride === "number" && isFinite(dirAngOverride)) {
    ang = dirAngOverride;
    ux = Math.cos(ang);
    uy = Math.sin(ang);
  } else {
  // ✅ Continuación armónica (según el trazo muestreado), no derivada matemática
  const hd = harmonicEndDirection(curvePx);
  ux = hd.ux;
  uy = hd.uy;
  ang = hd.ang;
}


  // ---- head sizing
  const headBase = 22;
  const headSize = (headBase + state.strokeWidth * 2) * state.zoom;

  // ---- cut point (where hook ends and head begins)
  const cut = headSize * 0.98;

  // Endpoint is the NECK; tip is pushed forward
  const ax = curvePx.a.x, ay = curvePx.a.y;
  const bx = curvePx.b.x, by = curvePx.b.y; // NECK (mouse)

  const bxCut = bx;
  const byCut = by;

  // ---- HOOK direction aligned to (ux,uy)
  const hookLen = Math.max(1, headSize * 0.1);
  const hx = bxCut - ux * hookLen;
  const hy = byCut - uy * hookLen;

  // Tip base (before push)
  const tipBaseX = bx + ux * cut;
  const tipBaseY = by + uy * cut;

  // ==========================================================
  // BODY
  // ==========================================================
  if (style === "dribble") {
    ctx.setLineDash([]); // dribble always solid

    // 1) sample base curve and force end at hook start (NOT at cut)
    let basePts = sampleCurvePx(curvePx, 140);
    if (!basePts.length) { ctx.restore(); return; }
    basePts[basePts.length - 1] = { x: hx, y: hy };

    // 2) uniform resample for harmonic wave
    const step = Math.max(2.8, Math.round(3.2 * state.zoom));
    const pts = resamplePolylineByStep(basePts, step);

    // 3) wave params
    const amp = Math.max(5, 11 * state.zoom);
    const waveLen = Math.max(9, 12.5 * state.zoom);

    // total length (for taper)
    let total = 0;
    for (let i = 1; i < pts.length; i++) {
      total += Math.hypot(pts[i].x - pts[i - 1].x, pts[i].y - pts[i - 1].y);
    }

    // taper only very near the neck (premium: no last wiggle)
    const taperPx = Math.max(8, headSize * 0.4);

    // 4) wavy points
    let dist = 0;
    const wavy = [];

    for (let i = 0; i < pts.length; i++) {
      const p = pts[i];

      if (i > 0) {
        dist += Math.hypot(p.x - pts[i - 1].x, p.y - pts[i - 1].y);
      }

      // smooth tangent using neighbors
      const pPrev = pts[Math.max(0, i - 1)];
      const pNext = pts[Math.min(pts.length - 1, i + 1)];
      const tx = pNext.x - pPrev.x;
      const ty = pNext.y - pPrev.y;
      const tLen = Math.hypot(tx, ty) || 1;

      // normal to smoothed tangent
      const nx = -ty / tLen;
      const ny =  tx / tLen;

      const phase = (dist / waveLen) * Math.PI * 2;
      const s = Math.sin(phase);
      const wave = Math.sign(s) * Math.pow(Math.abs(s), 0.55); // more "arrugada"

      const remaining = Math.max(0, total - dist);
      const taper = remaining < taperPx ? (remaining / taperPx) : 1;

      const off = wave * amp * taper;
      wavy.push({ x: p.x + nx * off, y: p.y + ny * off });
    }

    // 5) draw wavy smoothly
    ctx.beginPath();
    drawSmoothPolyline(ctx, wavy);
    ctx.stroke();

  } else {
    // solid/dash body to NECK (hook finishes clean straight)
    ctx.beginPath();
    ctx.moveTo(ax, ay);

    if (curvePx.type === "line") {
      ctx.lineTo(bxCut, byCut);
    } else if (curvePx.type === "quad") {
      ctx.quadraticCurveTo(curvePx.c1.x, curvePx.c1.y, bxCut, byCut);
    } else {
      ctx.bezierCurveTo(
        curvePx.c1.x, curvePx.c1.y,
        curvePx.c2.x, curvePx.c2.y,
        bxCut, byCut
      );
    }

    ctx.stroke();
  }

  // ==========================================================
  // HOOK (solid) - aligned to END TANGENT (ux,uy)
  // ==========================================================
  ctx.save();
  ctx.setLineDash([]);
  ctx.lineCap = "round";
  ctx.lineJoin = "round";
ctx.lineWidth = state.strokeWidth * exportMul;
ctx.strokeStyle = col;

  ctx.beginPath();
  ctx.moveTo(hx, hy);
  ctx.lineTo(bxCut, byCut);
  ctx.stroke();
  ctx.restore();

  // ==========================================================
  // HEAD (solid) - by override or tool
  // ==========================================================
  ctx.setLineDash([]);
  const headType = headTypeOverride || ((state.tool === "screen") ? "screen" : "arrow");

  // tiny push to cover join artifacts
const headPush = Math.max(1.5, headSize * 0.06);

const baseX = bxCut;  // NECK
const baseY = byCut;

const adv = (headType === "screen")
  ? headPush
  : (cut + headPush);   // ✅ para arrow/dribble

const tipX = baseX + ux * adv;
const tipY = baseY + uy * adv;



  ctx.save();
  ctx.translate(tipX, tipY);
  ctx.rotate(ang);

  if (headType === "screen") {
    // CAP perpendicular al trazo (mini recta a 90°)
    const capLen = headSize * 0.65;
    const capTh  = Math.max(2, state.strokeWidth * 1.15) * state.zoom;
    const capX = -capTh * 0.75; // antes 0.35

    ctx.beginPath();
    ctx.rect(capX, -capLen / 2, capTh, capLen);
    ctx.fillStyle = col; // ✅ Asegurar color justo antes de fill
    ctx.fill();
  } else {
    // classic solid arrowhead
    const L = headSize * 1.05;
    const H = headSize * 0.72;

    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.lineTo(-L, -H / 2);
    ctx.lineTo(-L,  H / 2);
    ctx.closePath();
    ctx.fillStyle = col; // ✅ Asegurar color justo antes de fill
    ctx.fill();
  }

  ctx.restore(); // head transform
  ctx.restore(); // function save
}


// ---------- Hit testing
// --- TEXT hit-test helpers ---
const __measureCv = document.createElement("canvas");
const __measureCtx = __measureCv.getContext("2d");

function hitTestText(frame, px, py, canvas){
  const objs = Array.isArray(frame?.objects) ? frame.objects : [];
  for (let i = objs.length - 1; i >= 0; i--){
    const o = objs[i];
    if (!o || o.type !== "text") continue;

    const x = (o.x ?? 0) * canvas.width;
    const y = (o.y ?? 0) * canvas.height;

    const size = Math.max(10, Math.min(60, Number(o.size ?? 22)));
    const txt  = String(o.text ?? "");
    if (!txt) continue;

    __measureCtx.font = `700 ${Math.round(size)}px Arial`;
    const w = __measureCtx.measureText(txt).width;
    const h = size;

    const pad = 8;
    if (px >= x - pad && px <= x + w + pad && py >= y - pad && py <= y + h + pad){
      return { index: i, obj: o };
    }
  }
  return null;
}

function hitTestIcon(frame, px, py, canvas){
  const w=canvas.width, h=canvas.height;
  for(let i=frame.objects.length-1;i>=0;i--){
    const o=frame.objects[i];
    if(o.type!=="icon") continue;

    const p=normToPx(o.x,o.y,w,h);
    const bw=o.w*w * ICON_RENDER_SCALE;
    const bh=o.h*h * ICON_RENDER_SCALE;
    const l=p.x-bw/2, t=p.y-bh/2, r=l+bw, b=t+bh;

    if(px<l||px>r||py<t||py>b) continue;

    const d = Math.hypot(px-r, py-b);
    const onHandle = d <= 10;
    return { index:i, obj:o, onHandle };
  }
  return null;
}

function distPointToSegment(px, py, ax, ay, bx, by) {
  const vx = bx - ax, vy = by - ay;
  const wx = px - ax, wy = py - ay;
  const c1 = vx*wx + vy*wy;
  if (c1 <= 0) return Math.hypot(px-ax, py-ay);
  const c2 = vx*vx + vy*vy;
  if (c2 <= c1) return Math.hypot(px-bx, py-by);
  const t = c1 / c2;
  const ix = ax + t*vx, iy = ay + t*vy;
  return Math.hypot(px-ix, py-iy);
}

function hitTestArrow(frame, px, py, canvas){
  const w=canvas.width, h=canvas.height;
  for(let i=frame.objects.length-1;i>=0;i--){
    const o=frame.objects[i];
    if(o.type!=="arrow") continue;

    const curvePx = normalizeCurveToPx(o.curve, w, h);
    const pts = sampleCurvePx(curvePx, 26);

    let best = Infinity;
    for(let k=0;k<pts.length-1;k++){
      best = Math.min(best, distPointToSegment(px, py, pts[k].x, pts[k].y, pts[k+1].x, pts[k+1].y));
      if(best <= 10) break;
    }
    if(best <= 10) return { index:i, obj:o, onHandle:false };
  }
  return null;
}

function moveCurveNorm(curveNorm, dxPx, dyPx, w, h){
  const dx = dxPx / w;
  const dy = dyPx / h;
  const add = (p)=>({ x: clamp(p.x + dx, 0, 1), y: clamp(p.y + dy, 0, 1) });

  if(curveNorm.type==="line"){
    curveNorm.a = add(curveNorm.a); curveNorm.b = add(curveNorm.b);
  } else if(curveNorm.type==="quad"){
    curveNorm.a = add(curveNorm.a); curveNorm.c1 = add(curveNorm.c1); curveNorm.b = add(curveNorm.b);
  } else {
    curveNorm.a = add(curveNorm.a); curveNorm.c1 = add(curveNorm.c1); curveNorm.c2 = add(curveNorm.c2); curveNorm.b = add(curveNorm.b);
  }
}
// ===== Curve handles (edit control points) =====
function getArrowHandlePtsPx(curveNorm, w, h){
  if(!curveNorm) return [];

  // solo mostramos handles para quad como ya venías haciendo
  if(curveNorm.type !== "quad") return [];

  const c1 = normToPx(curveNorm.c1.x, curveNorm.c1.y, w, h);
  const b  = normToPx(curveNorm.b.x,  curveNorm.b.y,  w, h);

  // === mover el handle "b" un poquito hacia atrás para que no tape la punta ===
  // usamos la tangente final del curve en px (misma lógica que ya usás para orientar head)
  let ux = 1, uy = 0;
  try{
    const curvePx = normalizeCurveToPx(curveNorm, w, h);
    const t = arrowEndTangent(curvePx);   // {ux, uy, ang}
    ux = t.ux; uy = t.uy;
  }catch{}

  // radio del círculo verde (mismo que render)
  const r = Math.max(6, Math.round(7 * state.zoom));
  const back = r * 1.35; // ajustable: 1.2–1.6

  const b2 = { x: b.x - ux * back, y: b.y - uy * back };

  return [
    { key:"c1", x:c1.x, y:c1.y },
    { key:"b",  x:b2.x, y:b2.y },
  ];
}






function hitTestArrowHandle(frame, px, py, canvas){
  const w = canvas.width, h = canvas.height;

  // tamaño del cuadrado amarillo (mismo que render)
  const s = Math.max(8, Math.round(10 * state.zoom));
  const half = s / 2;

  // radio del círculo verde (mismo que render)
  const r = Math.max(6, Math.round(7 * state.zoom));
  const grab = 6; // tolerancia para agarrar

  // 1) si hay seleccionado, probalo primero (mejor UX)
  if(state.selectedObjectId){
    const sel = frame.objects.find(o => o.id === state.selectedObjectId);
    const hitSel = hitHandleOnArrow(sel, px, py, w, h, half, r, grab);
    if(hitSel) return hitSel;
  }

  // 2) si no, probá todos (de arriba hacia abajo)
  for(let i = frame.objects.length - 1; i >= 0; i--){
    const o = frame.objects[i];
    const hit = hitHandleOnArrow(o, px, py, w, h, half, r, grab);
    if(hit) return hit;
  }

  return null;
}

// helper interno: testea handles sobre UNA flecha
function hitHandleOnArrow(o, px, py, w, h, half, r, grab){
  if(!o || o.type !== "arrow") return null;
  if(!o.curve || o.curve.type !== "quad") return null;

  const handles = getArrowHandlePtsPx(o.curve, w, h);
  if(!handles || !handles.length) return null;

  for(const hp of handles){
    if(!hp) continue;

    if(hp.key === "b"){
      const d = Math.hypot(px - hp.x, py - hp.y);
      if(d <= r + grab) return { id:o.id, key:"b" };
    } else {
      // c1 cuadrado
      if(
        px >= hp.x - half && px <= hp.x + half &&
        py >= hp.y - half && py <= hp.y + half
      ){
        return { id:o.id, key:"c1" };
      }
    }
  }
  return null;
}


function setCurveHandleNorm(curveNorm, key, nx, ny){
  if(!curveNorm) return;
  if(curveNorm.type !== "quad") return;

  const p = { x: clamp(nx, 0, 1), y: clamp(ny, 0, 1) };

  if(key === "c1") curveNorm.c1 = p;
  else if(key === "b") curveNorm.b = p;
}





// ---------- Delete badge (X)
function roundRect(ctx, x, y, w, h, r){
  const rr = Math.min(r, w/2, h/2);
  ctx.beginPath();
  ctx.moveTo(x+rr, y);
  ctx.arcTo(x+w, y, x+w, y+h, rr);
  ctx.arcTo(x+w, y+h, x, y+h, rr);
  ctx.arcTo(x, y+h, x, y, rr);
  ctx.arcTo(x, y, x+w, y, rr);
  ctx.closePath();
}

function drawDeleteBadge(ctx, x, y){
  const s = 18;
  ctx.save();
  ctx.fillStyle = "rgba(0,0,0,.86)";
  ctx.strokeStyle = "rgba(255,255,255,.86)";
  ctx.lineWidth = 1;
  roundRect(ctx, x, y, s, s, 4);
  ctx.fill();
  ctx.stroke();

  ctx.strokeStyle = "rgba(255,255,255,.92)";
  ctx.lineWidth = 2;
  ctx.beginPath();
  ctx.moveTo(x+5, y+5); ctx.lineTo(x+s-5, y+s-5);
  ctx.moveTo(x+s-5, y+5); ctx.lineTo(x+5, y+s-5);
  ctx.stroke();
  ctx.restore();
  return { x, y, w:s, h:s };
}
function applySmartToNextFrame(){
  const src = getSelectedFrame();
  if(!src) return;

  // 1) buscar índice del frame seleccionado (N)
  const idx = state.frames.findIndex(fr => fr.id === src.id);
  if(idx < 0) return;

  // 2) obtener el frame siguiente (N+1)
  let dst = state.frames[idx + 1];

  // 3) si no existe frame siguiente, crearlo (solo en ese caso)
  if(!dst){
    dst = newFrame(`Frame ${state.frames.length + 1}`);
    snapshotFrame(dst);
    state.frames.push(dst);
  }

  // 4) calcular el “smart” desde src (tu función ya devuelve SOLO players)
  const smart = buildSmartFrameFrom(src);
  const smartPlayers = Array.isArray(smart.objects) ? smart.objects : [];

  // 5) VOLCAR: en el frame siguiente quedan SOLO jugadores
  dst.objects = smartPlayers;

  // 6) guardar y seleccionar el frame siguiente
  snapshotFrame(dst);
  renderAll();
  selectFrame(dst.id);
}
function renumberFrames(){
  state.frames.forEach((fr, i) => {
    fr.label = `Frame ${i + 1}`;
  });
}
function addBallToSelected(){
  const f = getSelectedFrame();
  if(!f) return;

  const sel = f.objects.find(o => o.id === state.selectedObjectId);
  if(!sel || sel.type !== "icon"){
    setStatus(t('status_select_player'), null);
    return;
  }

  // ¿Es un jugador 1..5 sin balón?
  const m = String(sel.icon || "").match(/^([1-5])\.svg$/);
  if(!m){
    setStatus(t('status_select_player_noball'), null);
    return;
  }

  const num = m[1];                // "1".."5"
  const targetWithBall = `${num}c.svg`;

  // 1) Sacar balón a todos los jugadores que lo tengan (Nc.svg -> N.svg)
  for(const o of f.objects){
    if(o.type !== "icon") continue;
    const mc = String(o.icon || "").match(/^([1-5])c\.svg$/);
    if(mc){
      o.icon = `${mc[1]}.svg`;
    }
  }

  // 2) Poner balón al seleccionado (N.svg -> Nc.svg)
  sel.icon = targetWithBall;

  snapshotFrame(f);
  renderAll();
  setStatus(t('status_ball_assigned', num), null);
}

// ---------- Selection helpers

function framePxToCourtPx(px, py, w, h){
  const { s, ox, oy } = getCourtTransform(w, h);
  return { x: (px - ox) / s, y: (py - oy) / s };
}

function getCourtTransform(w, h){
  const s =
    (state.courtMode === "ob")
      ? (state.courtScale ?? 0.83)
      : 1.0;

  const ox = (w - w*s) * 0.5;
  const oy = (h - h*s) * 0.5;
  return { s, ox, oy };
}

function isInsideCourtWorld(px, py, w, h){
  const { s, ox, oy } = getCourtTransform(w, h);
  return (px >= ox && px <= ox + w*s && py >= oy && py <= oy + h*s);
}

function selectFrame(id){
  state.selectedFrameId = id;
  $$(".frameCard").forEach(c => {
    const isSel = c.dataset.id === id;
    c.classList.toggle("selected", isSel);
    c.classList.toggle("odActive", isSel); // 👈 clave para mobile CSS
  });
}

function getSelectedFrameCanvas(){
  // Agarra el canvas del frame actualmente seleccionado
  const card = document.querySelector('.frameCard.selected');
  return card ? card.querySelector('canvas') : null;
}

function moveCurveNormAny(curveNorm, dxPx, dyPx, w, h, clamp01){
  const dx = dxPx / w;
  const dy = dyPx / h;

  const add = (p)=>({
    x: clamp01 ? clamp(p.x + dx, 0, 1) : (p.x + dx),
    y: clamp01 ? clamp(p.y + dy, 0, 1) : (p.y + dy),
  });

  if(curveNorm.type === "line"){
    curveNorm.a = add(curveNorm.a); curveNorm.b = add(curveNorm.b);
  } else if(curveNorm.type === "quad"){
    curveNorm.a = add(curveNorm.a); curveNorm.c1 = add(curveNorm.c1); curveNorm.b = add(curveNorm.b);
  } else {
    curveNorm.a = add(curveNorm.a); curveNorm.c1 = add(curveNorm.c1); curveNorm.c2 = add(curveNorm.c2); curveNorm.b = add(curveNorm.b);
  }
}

function nudgeSelectedObject(dxPx, dyPx){
  const f = getSelectedFrame();
  if(!f || !state.selectedObjectId) return false;

  const canvas = getSelectedFrameCanvas();
  if(!canvas) return false;

  const obj = f.objects.find(o => o.id === state.selectedObjectId);
  if(!obj) return false;

  const clamp01 = (state.courtMode !== "ob"); // SET: clamp 0..1 | OB: dejar salir

  if(obj.type === "icon" || obj.type === "text"){
    const dx = dxPx / canvas.width;
    const dy = dyPx / canvas.height;

    obj.x = clamp01 ? clamp((obj.x ?? 0) + dx, 0, 1) : ((obj.x ?? 0) + dx);
    obj.y = clamp01 ? clamp((obj.y ?? 0) + dy, 0, 1) : ((obj.y ?? 0) + dy);

  } else if(obj.type === "arrow" && obj.curve){
    // OJO: tu moveCurveNorm original clamp-ea siempre (0..1). Para OB necesitamos opción sin clamp.
    moveCurveNormAny(obj.curve, dxPx, dyPx, canvas.width, canvas.height, clamp01);
  } else {
    return false;
  }

  snapshotFrame(f);
  renderAll();
  return true;
}

function getSelectedFrame(){
  return state.frames.find(f => f.id === state.selectedFrameId) || null;
}

function deleteSelectedObject(){
  const f = getSelectedFrame();
  if(!f || !state.selectedObjectId) return false;
  const idx = f.objects.findIndex(o => o.id === state.selectedObjectId);
  if(idx < 0) return false;

  f.objects.splice(idx, 1);
  snapshotFrame(f);
  state.selectedObjectId = null;
  renderAll();
  setStatus("Deleted", null);
  return true;
}
function getRotateHandlePxForLine(curveNorm, w, h){
  if(!curveNorm || curveNorm.type !== "line") return null;

  const a = normToPx(curveNorm.a.x, curveNorm.a.y, w, h);
  const b = normToPx(curveNorm.b.x, curveNorm.b.y, w, h);

  const dx = b.x - a.x, dy = b.y - a.y;
  const len = Math.hypot(dx, dy) || 1;
  const ux = dx / len, uy = dy / len;

  // handle un poquito "despegado" del final, y también separado lateralmente
  const back = 18 * state.zoom;     // hacia atrás desde el final
  const side = 14 * state.zoom;     // hacia el costado (normal)
  const nx = -uy, ny = ux;          // normal

  return {
    x: b.x - ux*back + nx*side,
    y: b.y - uy*back + ny*side
  };
}

function hitTestRotateHandleLine(frame, px, py, canvas){
  if(!state.selectedObjectId) return null;

  const o = frame.objects.find(x => x.id === state.selectedObjectId);
  if(!o || o.type !== "arrow") return null;
  if(!o.curve || o.curve.type !== "line") return null;

  const hp = getRotateHandlePxForLine(o.curve, canvas.width, canvas.height);
  if(!hp) return null;

  // área clickeable (cuadrado)
  const r = Math.max(12, Math.round(14 * state.zoom)); // half-size
  if(Math.abs(px - hp.x) <= r && Math.abs(py - hp.y) <= r){
    return { id: o.id };
  }
  return null;
}
function odGetPlayIdFromUrl(){
  const params = new URLSearchParams(window.location.search || "");
  return (params.get("playId") || "").trim();
}

function odRedirectOrganizer(){
  window.location.href = "./organizer.html";
}

// ---------- Rendering
function renderFrameCanvas(frame, canvas){
  const ctx = canvas.getContext("2d");
  const w = canvas.width;
  const h = canvas.height;

  // ✅ CRITICAL: reset any accumulated transforms each render
  ctx.setTransform(1, 0, 0, 1, 0, 0);

  // 1) frame blanco full (margen OB visible)
  ctx.clearRect(0, 0, w, h);
  ctx.fillStyle = "#fff";
  ctx.fillRect(0, 0, w, h);

const mode = state.courtMode || "set";
const s = (state.courtMode === "ob") ? (state.courtScale ?? 0.83) : 1.0;
const ox = (w - w*s) * 0.5;
const oy = (h - h*s) * 0.5;

  ctx.save();
  ctx.translate(ox, oy);
  ctx.scale(s, s);

  // 3) court
  if (COURT_IMG) ctx.drawImage(COURT_IMG, 0, 0, w, h);


  // 4) grid (si drawGrid ya chequea state.gridOn, ok; si no, envolvé con if)
  drawGrid(ctx, w, h);

  // 5) objetos (todo dentro del transform)
  for(const o of (frame.objects || [])){

    // -------------------------
    // ARROWS
    // -------------------------
    if(o.type === "arrow"){
      const curvePx = normalizeCurveToPx(o.curve, w, h);
const dir = (o.style === "dribble" && typeof o.dirAng === "number") ? o.dirAng : null;
drawArrow(ctx, curvePx, o.style || "solid", dir, o.head || "arrow", o.color || "#000");



      const isSel = (!state.isExporting && o.id === state.selectedObjectId);

      // --- control points handles for QUAD (yellow + green end)
      if(
        isSel &&
        o.curve && o.curve.type === "quad" &&
        typeof getArrowHandlePtsPx === "function"
      ){
        const handles = getArrowHandlePtsPx(o.curve, w, h);
        if(handles && handles.length){
          const size = Math.max(8, Math.round(10 * state.zoom));
          const half = size / 2;
          const r = Math.max(6, Math.round(7 * state.zoom));

          ctx.save();
          ctx.lineWidth = 1;

          for(const hp of handles){
            if(!hp) continue;

            if(hp.key === "b"){
              // green circle (end)
ctx.beginPath();
ctx.arc(hp.x, hp.y, r, 0, Math.PI * 2);
ctx.fillStyle = "#27AE60";
ctx.fill();
ctx.strokeStyle = "rgba(0,0,0,60)";
ctx.stroke();


            } else {
              // yellow square (c1 or a depending on your helper)
             ;
       ctx.beginPath();
ctx.rect(hp.x - half, hp.y - half, size, size);
ctx.fillStyle = "#ffd400";
ctx.fill();
ctx.strokeStyle = "rgba(0,0,0,75)";
ctx.stroke();

            }
          }

          ctx.restore();
        }
      }

      // --- rotate handle for straight LINE arrows (green circle)
      if(
        isSel &&
        o.curve && o.curve.type === "line" &&
        typeof getRotateHandlePxForLine === "function"
      ){
        const hp = getRotateHandlePxForLine(o.curve, w, h);
        if(hp){
          const r = Math.max(6, Math.round(7 * state.zoom));
          ctx.save();
          
          ctx.beginPath();
          ctx.arc(hp.x, hp.y, r, 0, Math.PI * 2);
          ctx.fillStyle = "#27AE60";
          ctx.fill();
          ctx.strokeStyle = "rgba(0,0,0,.60)";
          ctx.lineWidth = 1;
          ctx.stroke();
          ctx.restore();
        }
      }

      continue;
    }

    // -------------------------
    // ICONS
    // -------------------------
    if(o.type === "icon"){
      const img = ICON_CACHE.get(o.icon);
      if(!img) continue;

    const allowOOB = (state.courtMode === "ob");

const p = allowOOB
  ? { x: o.x * w, y: o.y * h }         // ✅ sin clamp
  : normToPx(o.x, o.y, w, h);          // ✅ clamp normal para set

      const bw = o.w * w * ICON_RENDER_SCALE;
      const bh = o.h * h * ICON_RENDER_SCALE;

      // 1) draw png/svg raster
      const col = o.color || "#000";
const srcImg = (col && col !== "#000") ? getTintedIconCanvas(img, col) : img;
ctx.drawImage(srcImg, p.x - bw/2, p.y - bh/2, bw, bh);

      // 2) selection rect (only smart icons)
      if(
        !state.isExporting &&
        o.id === state.selectedObjectId &&
        typeof SMART_ICON_SET !== "undefined" &&
        SMART_ICON_SET.has(o.icon)
      ){
        ctx.save();
        ctx.strokeStyle = "rgba(26,115,232,0.95)";
        ctx.lineWidth = 2;
        ctx.setLineDash([6,4]);
const pad = 1;
ctx.strokeRect(p.x - bw/2 - pad, p.y - bh/2 - pad, bw + pad*2, bh + pad*2);
        ctx.setLineDash([]);
        ctx.restore();
      }

      // 3) resize handle (bottom-right)
      if(!state.isExporting && o.id === state.selectedObjectId){
ctx.save();
ctx.fillStyle = "rgba(26,115,232,0.95)";
ctx.beginPath();
ctx.arc(p.x + bw/2, p.y + bh/2, 6, 0, Math.PI * 2);
ctx.fill();
ctx.restore();
      }

      continue;
    }

    // -------------------------
    // TEXT
    // -------------------------
    // -------------------------
    // TEXT
    // -------------------------
    if(o.type === "text"){
      const allowOOB = (state.courtMode === "ob");
      const p = allowOOB
        ? { x: (o.x ?? 0) * w, y: (o.y ?? 0) * h }
        : normToPx(o.x ?? 0, o.y ?? 0, w, h);

      const txt = String(o.text ?? o.value ?? "");
      const size = clamp(Number(o.size ?? 18), 10, 60);
      const pxSize = Math.round(size * state.zoom);

      ctx.save();
      ctx.fillStyle = o.color || "#111";
      ctx.font = `700 ${pxSize}px Montserrat`;
      ctx.textAlign = "left";
      ctx.textBaseline = "top";
      ctx.fillText(txt, p.x, p.y);

      // ✅ selection rect (blue) like other elements
      if(!state.isExporting && o.id === state.selectedObjectId){
        const m = ctx.measureText(txt || " ");
        const tw = m.width;
        const th = pxSize * 1.15;       // aproximación visual consistente
        const pad = Math.max(2, Math.round(4 * state.zoom));

        ctx.strokeStyle = "rgba(26,115,232,0.95)";
        ctx.lineWidth = 2;
        ctx.setLineDash([6,4]);
        ctx.strokeRect(p.x - pad, p.y - pad, tw + pad*2, th + pad*2);
        ctx.setLineDash([]);
      }

      ctx.restore();
      continue;
    }


  
  }
  // -------------------------
  // LIVE PREVIEW (arrow while dragging)
  // -------------------------
  if(!state.isExporting && canvas._previewStroke && canvas._previewStroke.length > 1){
    let curve = harmonizeStroke(canvas._previewStroke);

    if(curve && canvas._previewLineMode === "straight"){
      curve = forceCurveToStraight(curve);
    }

    if(curve){
      const t = canvas._previewTool;

      const style =
        (t === "arrowDash") ? "dash" :
        (t === "dribble")   ? "dribble" :
        "solid";

      const headType = (t === "screen") ? "screen" : "arrow";

      const dirAngOverride =
        (t === "dribble")
          ? finalAngleFromRawStroke(canvas._previewStrokeRaw, state.zoom)
          : null;

drawArrow(ctx, curve, style, dirAngOverride, headType, "#111");

    }
  }

  // ✅ salir del mundo cancha
  ctx.restore();

  // ✅ overlays NO-escaleados (si tenés delete badge u otras UI), van acá afuera
  // (si no tenés, no pongas nada)
}


// ---------- UI build
function ensureSelectArrowButton(){
  const toolbar = document.querySelector(".toolbar");
  if(!toolbar || !undoBtn) return;

  const existing = document.getElementById("selectArrowBtn");
  if(existing){
    selectArrowBtn = existing;
    return;
  }

  const btn = document.createElement("button");
  btn.id = "selectArrowBtn";
  btn.className = "tbtn isIcon";
  btn.type = "button";
  btn.title = "Select";
  btn.innerHTML = `
    <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
      <path fill="currentColor" d="M5 3l14 10-8 2 2 8-3 1-2-8-5 5V3z"/>
    </svg>
  `;

  undoBtn.parentElement.insertBefore(btn, undoBtn.nextSibling);
  selectArrowBtn = btn;

  btn.addEventListener("click", ()=>{
    state.selectedIcon = null;
    $$(".iconBtn").forEach(b=>{ if(b.dataset.icon) b.classList.remove("active"); });
    setTool("select");
    setStatus("Select: click an icon/arrow to move, Delete to remove", "Tool: Select");
  });
}

function ensureArrowsPanel(){
  // (si querés re-activar el panel en el futuro, sacá este return)
  return;

  /*
  if(document.getElementById("arrowsPanel")){
    arrowGridEl = $("#arrowGrid");
    return;
  }

  const panel = document.createElement("div");
  panel.className = "panel";
  panel.id = "arrowsPanel";
  panel.innerHTML = `
    <div class="panelTitle">Arrows</div>
    <div id="arrowGrid" class="iconGrid"></div>
    <div class="hint">Tip: elegí punta → Tool Arrow / Arrow Dash / Dribble → arrastrá en el frame.</div>
  `;

  const iconsPanel = iconGrid ? iconGrid.closest(".panel") : null;
  if(iconsPanel) iconsPanel.insertAdjacentElement("afterend", panel);
  else sidebar.appendChild(panel);

  arrowGridEl = panel.querySelector("#arrowGrid");
  arrowGridEl.innerHTML = "";

  ARROWHEAD_FILES.forEach(filename=>{
    const b = document.createElement("button");
    b.className="iconBtn";
    b.dataset.arrowhead = filename;

    const img = document.createElement("img");
    img.src = ARROWHEAD_BASE_PATH + filename;
    img.alt = filename;

    b.appendChild(img);
    b.addEventListener("click", ()=>{
      state.selectedIcon = null;
      $$(".iconBtn").forEach(x=>{ if(x.dataset.icon) x.classList.remove("active"); });
      setSelectedArrowhead(filename);
      if(state.tool !== "arrowDash" && state.tool !== "dribble") setTool("arrow");
    });

    arrowGridEl.appendChild(b);
  });

  setSelectedArrowhead(state.selectedArrowhead || "arrow.svg");
  */
}

function renderIconSidebar(){
  if(!iconGrid) return;
  iconGrid.innerHTML = "";

  ICON_FILES.forEach(filename=>{
    const b = document.createElement("button");
    b.className="iconBtn";
    b.dataset.icon = filename;

    const img = document.createElement("img");
    img.src = ICON_BASE_PATH + filename;
    img.alt = filename;

    b.appendChild(img);
    b.addEventListener("click", ()=>{
      setSelectedIcon(filename);
      if(selectArrowBtn) selectArrowBtn.classList.remove("active");
    });

    iconGrid.appendChild(b);
  });

if (state.selectedIcon) {
  setSelectedIcon(state.selectedIcon);
} else {
  // No icon selected by default: keep Select behavior
  $$(".iconBtn").forEach(b => { if (b.dataset.icon) b.classList.remove("active"); });
}

}

function renderAll(){
  if(!framesGrid) return;

  framesGrid.innerHTML = "";
  const framesMeta = $("#framesMeta");
  if(framesMeta) framesMeta.textContent = `${state.frames.length} frames`;

  state.frames.forEach((frame, idx)=>{
    const card = document.createElement("div");
    card.className="frameCard";
    card.dataset.id = frame.id;

    const top = document.createElement("div");
    top.className="frameTop";

    const label = document.createElement("div");
    label.className="frameLabel";
    label.textContent = frame.label || `Frame ${idx+1}`;

    const actions = document.createElement("div");
    actions.className="frameActions";

const pill = document.createElement("div");
pill.className = "pill";
pill.textContent = `#${idx+1}`;

// ✅ botón delete frame
const del = document.createElement("button");
del.className = "frameDelBtn";
del.type = "button";
del.title = t('title_delete_frame');
del.textContent = "×";

del.addEventListener("click", (ev) => {
  ev.preventDefault();
  ev.stopPropagation(); // IMPORTANT: que no dispare selectFrame()

  // opcional: evitar borrar si hay 1 solo
  if(state.frames.length <= 1){
    setStatus(t('status_cant_delete_last'), null);
    return;
  }

  if(!confirm(t('confirm_delete_frame', frame.label || `Frame ${idx+1}`))) return;

  const i = state.frames.findIndex(fr => fr.id === frame.id);
  if(i >= 0) state.frames.splice(i, 1);
renumberFrames();


  // si borraste el seleccionado, seleccionar uno cercano
  if(state.selectedFrameId === frame.id){
    const fallback = state.frames[Math.min(i, state.frames.length - 1)];
    state.selectedFrameId = fallback ? fallback.id : null;
    state.selectedObjectId = null;
  }

  renderAll();
  setStatus(t('status_frame_deleted'), null);
odAutosave("Frame deleted");  // ← agregar esta línea

});

actions.appendChild(pill);
actions.appendChild(del);

    top.appendChild(label);
    top.appendChild(actions);

    const wrap = document.createElement("div");
    wrap.className="frameCanvasWrap";

    const canvas = document.createElement("canvas");
    canvas.className="frameCanvas";
    canvas.width = Math.round(FRAME_W * state.zoom);
    canvas.height = Math.round(FRAME_H * state.zoom);
    wrap.appendChild(canvas);

const desc = document.createElement("input");
desc.type = "text";
desc.className = "frameDesc";
desc.placeholder = "Frame description";
desc.value = frame.desc || "";
desc.maxLength = 40;

desc.addEventListener("input", (e) => {
  frame.desc = e.target.value;
odAutosave("Frame desc");
});

// para que no active selección/drag del frame al escribir
desc.addEventListener("mousedown", (e) => e.stopPropagation());
desc.addEventListener("click", (e) => e.stopPropagation());



    card.appendChild(top);
    card.appendChild(wrap);
    card.appendChild(desc);

    card.addEventListener("click", ()=>selectFrame(frame.id));

    attachCanvasHandlers(frame, canvas);
    renderFrameCanvas(frame, canvas);

    framesGrid.appendChild(card);
  });

  if(!state.selectedFrameId && state.frames[0]) selectFrame(state.frames[0].id);
  else if(state.selectedFrameId) selectFrame(state.selectedFrameId);

// Default: Select only once on page load
if (!window.__od_editorBooted) {
  window.__od_editorBooted = true;

  state.selectedIcon = null; // no stamp por defecto
  $$(".iconBtn").forEach(b => { if (b.dataset.icon) b.classList.remove("active"); });

  setTool("select");
  setStatus("Ready", "Tool: Select");
}

}

// ---------- Canvas interactions
// ---------- Canvas interactions
function attachCanvasHandlers(frame, canvas){
  let dragging = null;          // { id, kind:"icon"/"arrow", mode:"move"/"resize"/"handle", ... }
  let arrowStroke = null;       // [{x,y}...] px (snapped, for curve)
  let arrowStrokeRaw = null;    // [{x,y}...] px (raw, for final direction)

  // --------------------------------------------------
  // Helpers (locales al canvas)
  // --------------------------------------------------
  function clamp(v,a,b){ return Math.max(a, Math.min(b,v)); }

function getMousePx(e, { clampToCourt=true} = {}){
  const rect = canvas.getBoundingClientRect();
  let fx = (e.clientX - rect.left) * (canvas.width / rect.width);
  let fy = (e.clientY - rect.top)  * (canvas.height / rect.height);

  if(state.courtMode !== "ob"){
    return { px: fx, py: fy };
  }

  // OB: si estás dragueando y querés, podés clampear al frame (no al court)
  if(clampToCourt){
    fx = Math.max(0, Math.min(canvas.width, fx));
    fy = Math.max(0, Math.min(canvas.height, fy));
  }

  // Convert FRAME -> COURT WORLD aunque esté en el margen
  const cp = framePxToCourtPx(fx, fy, canvas.width, canvas.height);
  return { px: cp.x, py: cp.y };
}


  // --------------------------------------------------
  // MOUSEDOWN
  // --------------------------------------------------
  canvas.addEventListener("mousedown", (e)=>{
  selectFrame(frame.id);

  // --------------------------------------------------
  // Mouse position (court-world aware)
  // --------------------------------------------------
const m = getMousePx(e);
const px = m.px;
const py = m.py;


  // --------------------------------------------------
  // Delete badge
  // --------------------------------------------------
  if(canvas._deleteBadge && state.selectedObjectId){
    const b = canvas._deleteBadge;
    if(px>=b.x && px<=b.x+b.w && py>=b.y && py<=b.y+b.h){
      const idx = frame.objects.findIndex(o=>o.id===state.selectedObjectId);
      if(idx>=0){
        frame.objects.splice(idx, 1);
        snapshotFrame(frame);
        state.selectedObjectId = null;
        renderAll();
        setStatus("Deleted", null);
        return;
      }
    }
  }

  // --------------------------------------------------
  // ICON STAMPING
  // --------------------------------------------------
  if(state.selectedIcon){
    const img = ICON_CACHE.get(state.selectedIcon);
    if(!img) return;

const useSnap = (state.courtMode !== "ob"); // en OB: libre para salir
const p2 = useSnap ? snapPx(px, py, canvas.width, canvas.height) : { x:px, y:py };
const n = pxToNorm(p2.x, p2.y, canvas.width, canvas.height);


    const aspect = img.width / img.height;
    const initPxW = 42 * state.zoom;

    let wNorm = clamp(initPxW / canvas.width, 0.02, 0.30);
    let hNorm = heightNormFromWidthNorm(wNorm, aspect, canvas.width, canvas.height);

    if(hNorm > 0.30){
      hNorm = 0.30;
      wNorm = clamp((hNorm * aspect * canvas.height) / canvas.width, 0.02, 0.30);
      hNorm = heightNormFromWidthNorm(wNorm, aspect, canvas.width, canvas.height);
    }

    const obj = {
      id: uid(),
      type: "icon",
      icon: state.selectedIcon,
      x: n.x,
      y: n.y,
      w: wNorm,
      h: hNorm,
      aspect
    };

    frame.objects.push(obj);
    state.selectedObjectId = obj.id;
    snapshotFrame(frame);
    renderAll();

    // salir de stamping
    state.selectedIcon = null;
    $$(".iconBtn").forEach(b=>{
      if(b.dataset.icon) b.classList.remove("active");
    });
    setTool("select");
    setStatus("Placed icon. Back to Select", "Tool: Select");
    return;
  }
  // --------------------------------------------------
  // TEXT TOOL (stamp)
  // --------------------------------------------------
  if(state.tool === "text"){
    const allowOOB = (state.courtMode === "ob");
    const useSnap = !allowOOB; // en OB: libre
    const p2 = useSnap ? snapPx(px, py, canvas.width, canvas.height) : { x:px, y:py };
    const n = pxToNorm(p2.x, p2.y, canvas.width, canvas.height);

    const t = prompt("Text:");
    const txt = (t == null) ? "" : String(t).trim();
    if(!txt){
      setStatus("Text: cancelled", null);
      return;
    }

    const obj = {
      id: uid(),
      type: "text",
      text: txt,            // ✅ clave principal
      value: txt,           // ✅ compat por si algo aún lee value
      x: n.x,
      y: n.y,
      size: 18,             // default
      color: state.color || "#000"
    };

    frame.objects.push(obj);
    state.selectedObjectId = obj.id;
    snapshotFrame(frame);
    renderAll();

    setTool("select");
    setStatus("Placed text. Back to Select", "Tool: Select");
    return;
  }

  // --------------------------------------------------
  // ARROW TOOLS
  // --------------------------------------------------
  if(
    state.tool === "arrow" ||
    state.tool === "screen" ||
    state.tool === "arrowDash" ||
    state.tool === "dribble"
  ){
    arrowStroke = [];
    arrowStrokeRaw = [];

    // raw (for direction)
    arrowStrokeRaw.push({ x:px, y:py });

    // snapped (for curve)
    const s = snapPx(px, py, canvas.width, canvas.height);
    arrowStroke.push({ x:s.x, y:s.y });
  // expose preview to renderer
  canvas._previewStroke = arrowStroke;
  canvas._previewStrokeRaw = arrowStrokeRaw;
  canvas._previewTool = state.tool;
  canvas._previewLineMode = state.lineMode;

    setStatus("Arrow: dragging…", null);
    return;
  }
// --------------------------------------------------
// TEXT TOOL: click to place text
// --------------------------------------------------
if (state.tool === "text") {
  const frame = state.frames?.[state.activeFrameIndex ?? 0];
  if (!frame) return;

  const n = pxToNorm(px, py, canvas.width, canvas.height); // si ya tenés esta helper
  const txt = prompt("Text:", "");
  if (!txt) { setStatus?.("Text canceled"); return; }

  const obj = {
    id: uid(),
    type: "text",
    x: n.x,
    y: n.y,
    value: String(txt),
text: String(txt), // opcional: compat con od_renderer/export

    size: 22,
    color: state.color || "#111"
  };

  // clamp solo en SET (si OB es libre)
  if (state.courtMode !== "ob") {
    obj.x = Math.max(0, Math.min(1, obj.x));
    obj.y = Math.max(0, Math.min(1, obj.y));
  }

  frame.objects = Array.isArray(frame.objects) ? frame.objects : [];
  frame.objects.push(obj);

  state.selectedObjectId = obj.id;
  snapshotFrame(frame);
  renderAll();

  // opcional: volver a select automáticamente
  setTool?.("select");
  setStatus?.("Text placed", "Tool: Select");
  return;
}

  // --------------------------------------------------
  // SELECT TOOL
  // --------------------------------------------------
  if(state.tool === "select"){
    arrowStroke = null;
    arrowStrokeRaw = null;
canvas._previewStroke = null;
canvas._previewStrokeRaw = null;
canvas._previewTool = null;
canvas._previewLineMode = null;


    // curve handle
    const h = hitTestArrowHandle(frame, px, py, canvas);
    if(h){
      state.selectedObjectId = h.id;
      dragging = {
        id: h.id,
        kind: "arrow",
        mode: "handle",
        handleKey: h.key
      };
      renderFrameCanvas(frame, canvas);
      setStatus(`Curve handle: ${h.key}`, null);
      return;
    }

    // rotate handle (straight line)
    const rh = hitTestRotateHandleLine(frame, px, py, canvas);
    if(rh){
      state.selectedObjectId = rh.id;
      dragging = {
        id: rh.id,
        kind: "arrow",
        mode: "rotateLine"
      };
      renderFrameCanvas(frame, canvas);
      setStatus("Rotate line: drag ↻", null);
      return;
    }

const hit =
  hitTestIcon(frame, px, py, canvas) ||
  hitTestArrow(frame, px, py, canvas) ||
  hitTestText(frame, px, py, canvas);

    if(hit){
      state.selectedObjectId = hit.obj.id;

      if(hit.obj.type === "icon"){
        const p = normToPx(hit.obj.x, hit.obj.y, canvas.width, canvas.height);
        if(hit.onHandle){
          dragging = {
            id: hit.obj.id,
            kind: "icon",
            mode: "resize",
            startPx: px,
            startW: hit.obj.w,
            aspect: hit.obj.aspect || 1
          };
        } else {
          dragging = {
            id: hit.obj.id,
            kind: "icon",
            mode: "move",
            offsetX: px - p.x,
            offsetY: py - p.y
          };
        }
      }

      if(hit.obj.type === "arrow"){
        dragging = {
          id: hit.obj.id,
          kind: "arrow",
          mode: "move",
          lastPx: px,
          lastPy: py
        };
      }
if(hit.obj.type === "text"){
  dragging = {
    id: hit.obj.id,
    kind: "text",
    mode: "move",
    lastPx: px,
    lastPy: py
  };
}

      renderFrameCanvas(frame, canvas);
    } else {
      state.selectedObjectId = null;
      renderFrameCanvas(frame, canvas);
    }
    return;
  }

  // --------------------------------------------------
  // DELETE TOOL
  // --------------------------------------------------
  if(state.tool === "delete"){
const hit =
  hitTestIcon(frame, px, py, canvas) ||
  hitTestArrow(frame, px, py, canvas) ||
  hitTestText(frame, px, py, canvas);

    if(hit){
      frame.objects.splice(hit.index, 1);
      snapshotFrame(frame);
      state.selectedObjectId = null;
      renderAll();
    }
    return;
  }
});


  // --------------------------------------------------
  // MOUSEMOVE
  // --------------------------------------------------
  canvas.addEventListener("mousemove", (e)=>{
    const m = getMousePx(e, { clampToCourt: !!dragging || !!arrowStroke });
    let px = m.px, py = m.py;

    if(dragging){
      const obj = frame.objects.find(o=>o.id===dragging.id);
      if(!obj) return;

    if(dragging.kind==="arrow" && dragging.mode==="handle"){
  const s = snapPx(px, py, canvas.width, canvas.height);
  setCurveHandleNorm(obj.curve, dragging.handleKey, s.x/canvas.width, s.y/canvas.height);
  
  // ✅ Si es dribble, recalcular el ángulo de la punta según la nueva tangente
  if(obj.style === "dribble"){
    obj.dirAng = getFinalTangentAngle(obj.curve);
  }
  
  renderFrameCanvas(frame, canvas);
  return;
}

      if(dragging.kind==="arrow" && dragging.mode==="rotateLine"){
        const s = snapPx(px, py, canvas.width, canvas.height);
        obj.curve.b = pxToNorm(s.x, s.y, canvas.width, canvas.height);
        renderFrameCanvas(frame, canvas);
        return;
      }

      if(dragging.kind==="arrow" && dragging.mode==="move"){
        moveCurveNorm(obj.curve, px-dragging.lastPx, py-dragging.lastPy, canvas.width, canvas.height);
        dragging.lastPx = px; dragging.lastPy = py;
        renderFrameCanvas(frame, canvas);
        return;
      }
if(dragging.kind==="text" && dragging.mode==="move"){
  const dx = (px - dragging.lastPx) / canvas.width;
  const dy = (py - dragging.lastPy) / canvas.height;

  obj.x = (obj.x ?? 0) + dx;
  obj.y = (obj.y ?? 0) + dy;

  if(state.courtMode !== "ob"){
    obj.x = clamp(obj.x, 0, 1);
    obj.y = clamp(obj.y, 0, 1);
  }

  dragging.lastPx = px; dragging.lastPy = py;
  renderFrameCanvas(frame, canvas);
  return;
}

      // move icon
function clampIconInSet(nx, ny, wNorm = 0.08, hNorm = 0.08, canvasW, canvasH){
  // bordes lógicos del SVG en px
  const baseMarginPx = 6;

  // ajustes finos que querés:
  const sideExtraPx = 1;   // +1px a izquierda y derecha
  const topLessPx   = -1;  // -1px arriba (o sea deja subir 1px más)

  const marginLeftPx   = baseMarginPx - sideExtraPx; // 5
  const marginRightPx  = baseMarginPx - sideExtraPx; // 5
const marginTopPx    = baseMarginPx + topLessPx + 3; // +1px (corta antes arriba)
  const marginBottomPx = baseMarginPx;               // 6 (igual)

  // tamaño efectivo del icono en px
  const wPx = (wNorm ?? 0.08) * canvasW;
  const hPx = (hNorm ?? 0.08) * canvasH;

  const halfW = wPx / 2;
  const halfH = hPx / 2;

  // convertir nx/ny a px
  let xPx = nx * canvasW;
  let yPx = ny * canvasH;

  // clamp en px
  xPx = Math.max(marginLeftPx + halfW, Math.min(canvasW - marginRightPx - halfW, xPx));
  yPx = Math.max(marginTopPx  + halfH, Math.min(canvasH - marginBottomPx - halfH, yPx));

  // volver a normalizado
  return {
    x: xPx / canvasW,
    y: yPx / canvasH,
  };
}

// move icon
if(dragging.kind === "icon" && dragging.mode === "move"){
  const tx = px - dragging.offsetX;
  const ty = py - dragging.offsetY;

  const p2 =
    (state.courtMode === "ob")
      ? { x: tx, y: ty }
      : snapPx(tx, ty, canvas.width, canvas.height);

  let nx = p2.x / canvas.width;
  let ny = p2.y / canvas.height;

  if(state.courtMode === "ob"){
    // OB: si querés permitir salir, dejalo así:
    obj.x = clamp(nx, -0.50, 1.50);
    obj.y = clamp(ny, -0.50, 1.50);
  } else {
    // SET: NO puede salir del court y NO toca borde 6px
    const w = obj.w ?? 0.08;
    const h = obj.h ?? 0.08;
const p = clampIconInSet(nx, ny, obj.w, obj.h, canvas.width, canvas.height);
obj.x = p.x;
obj.y = p.y;
  }

  renderFrameCanvas(frame, canvas);
  return;
}



      if(dragging.kind==="icon" && dragging.mode==="resize"){
        const dx = px - dragging.startPx;
        let newW = clamp(dragging.startW + dx/canvas.width, 0.02, 0.6);
        let newH = heightNormFromWidthNorm(newW, dragging.aspect||1, canvas.width, canvas.height);
        if(newH>0.6){
          newH=0.6;
          newW = clamp((newH*(dragging.aspect||1)*canvas.height)/canvas.width, 0.02, 0.6);
          newH = heightNormFromWidthNorm(newW, dragging.aspect||1, canvas.width, canvas.height);
        }
        obj.w=newW; obj.h=newH;
        renderFrameCanvas(frame, canvas);
        return;
      }
    }

    // LIVE ARROW PREVIEW
    if(arrowStroke){
      arrowStrokeRaw?.push({x:px,y:py});
      const s = snapPx(px, py, canvas.width, canvas.height);
      arrowStroke.push({x:s.x,y:s.y});
      renderFrameCanvas(frame, canvas);
      return;
    }
  });
function clearFrozenAngleIfNeeded(obj){
  if(!obj || obj.type !== "arrow") return;
  if((obj.style || "solid") === "dribble") return; // dribble queda congelado a propósito
  if("dirAng" in obj) delete obj.dirAng;           // solid/dash vuelven a ser "vivos"
}

  // --------------------------------------------------
  // MOUSEUP
  // --------------------------------------------------
canvas.addEventListener("mouseup", (e) => {
  // para coherencia OB: clamp
  getMousePx(e, { clampToCourt: true });

  // ---------------------------
  // 1) Si estabas dibujando una flecha (stroke)
  // ---------------------------
  if (arrowStroke) {
    let curve = harmonizeStroke(arrowStroke);

    const dirAngOverride =
      (state.tool === "dribble")
        ? finalAngleFromRawStroke(arrowStrokeRaw, state.zoom)
        : null;

    // limpiar previews
    arrowStroke = null;
    arrowStrokeRaw = null;
    canvas._previewStroke = null;
    canvas._previewStrokeRaw = null;
    canvas._previewTool = null;
    canvas._previewLineMode = null;

    // forzar recta si está en modo straight
    if (curve && state.lineMode === "straight") {
      curve = forceCurveToStraight(curve);
    }

    if (curve) {
      const headType = (state.tool === "screen") ? "screen" : "arrow";

      const newArrow = {
        id: uid(),
        type: "arrow",
        head: headType,
        curve: curveToNorm(curve, canvas.width, canvas.height),

        // dribble sí guarda dirección congelada
        dirAng: (state.tool === "dribble") ? dirAngOverride : null,

        style:
          state.tool === "arrowDash" ? "dash" :
          state.tool === "dribble"  ? "dribble" :
          "solid",
      };

      frame.objects.push(newArrow);
      state.selectedObjectId = newArrow.id;

      snapshotFrame(frame);
      renderAll();
      setTool("select");
      setStatus("Arrow added. Back to Select", "Tool: Select");
    } else {
      renderFrameCanvas(frame, canvas);
      setStatus("Arrow canceled", null);
    }
    return;
  }

  // ---------------------------
  // 2) Si estabas arrastrando/editar (handlers, mover objetos, etc.)
  // ---------------------------
 if (dragging) {
  // buscar el objeto seleccionado de forma segura
  const selectedObj = frame.objects.find(o => o.id === state.selectedObjectId);

  // si es una flecha normal (no dribble), soltamos la punta
  if (selectedObj && selectedObj.type === "arrow" && selectedObj.style !== "dribble") {
    selectedObj.dirAng = null;   // NO delete
  }

  dragging = null;

  snapshotFrame(frame);
  renderAll();
}

});



  // --------------------------------------------------
  // WHEEL (icon resize)
  // --------------------------------------------------
  canvas.addEventListener("wheel", (e)=>{
    const f = getSelectedFrame();
    if(!f) return;
    const obj = f.objects.find(o=>o.id===state.selectedObjectId);
    if(!obj || obj.type!=="icon") return;

    e.preventDefault();
    const factor = Math.sign(e.deltaY)>0 ? 0.92 : 1.08;

    let newW = clamp(obj.w*factor, 0.02, 0.6);
    let newH = heightNormFromWidthNorm(newW, obj.aspect||1, canvas.width, canvas.height);
    if(newH>0.6){
      newH=0.6;
      newW = clamp((newH*(obj.aspect||1)*canvas.height)/canvas.width, 0.02, 0.6);
      newH = heightNormFromWidthNorm(newW, obj.aspect||1, canvas.width, canvas.height);
    }

    obj.w=newW; obj.h=newH;
    snapshotFrame(f);
    renderAll();
  }, { passive:false });
}

async function initRenderer() {
  setRendererPaths({
    courtSrc: "./court.svg",
    iconBase: "./icons/",
    iconRenderScale: 2.0
  });

  await ensureAssetsLoaded();
}

initRenderer();



// ---------- PDF Export (2 cols x 3 rows per page = max 6 frames)
function frameHasContent(frame) {
  if (!frame) return false;

  // Caso 1: todo vive en un array único
  if (Array.isArray(frame.objects)) return frame.objects.length > 0;

  // Caso 2: por colecciones
  const counts =
    (frame.players?.length || 0) +
    (frame.icons?.length || 0) +
    (frame.arrows?.length || 0) +
    (frame.lines?.length || 0) +
    (frame.texts?.length || 0);

  return counts > 0;
}
function frameNeedsOBView(frame){
  const objs = frame?.objects || [];
  for(const o of objs){
    if(o.type === "icon"){
      if(o.x < 0 || o.x > 1 || o.y < 0 || o.y > 1) return true;
    }
    if(o.type === "arrow" && o.curve){
      const c = o.curve;
      // line: a,b
      if(c.type === "line"){
        if([c.a?.x,c.a?.y,c.b?.x,c.b?.y].some(v => typeof v==="number" && (v<0 || v>1))) return true;
      }
      // quad: a,c1,b
      if(c.type === "quad"){
        if([c.a?.x,c.a?.y,c.c1?.x,c.c1?.y,c.b?.x,c.b?.y].some(v => typeof v==="number" && (v<0 || v>1))) return true;
      }
    }
  }
  return false;
}

async function saveEditorPostExportFeedback({ stars, comment, lang }) {
  const firebaseRef = window.firebase;
  const db = window.dbCompat || firebaseRef?.firestore?.();
  if (!db) throw new Error("feedback-db-missing");
  const user = firebaseRef?.auth?.().currentUser || null;
  const payload = {
    uid: user?.uid || window.currentUid || null,
    stars,
    suggestion: comment || "",
    comment: comment || "",
    lang,
    source: "post_export_share",
    exportKind: "play",
    timestamp: firebaseRef.firestore.FieldValue.serverTimestamp()
  };
  await db.collection("feedback").add(payload);
}

function showPostExportShareCTA(){
  if (document.getElementById("odPostExportShare")) return;
  const isEs = (navigator.language || "").toLowerCase().startsWith("es");
  const title = isEs ? "Jugada exportada" : "Play exported";
  const text = isEs
    ? "Compartila con otro entrenador o recomendale OpenDraw a tu staff."
    : "Send it to another coach or share OpenDraw with your staff.";
  const shareText = isEs
    ? "Chequea esta jugada armada en OpenDraw.pro: https://www.opendraw.pro"
    : "Check out this play built in OpenDraw.pro: https://www.opendraw.pro";
  const ratingTitle = isEs ? "Califica OpenDraw" : "Rate OpenDraw";
  const commentPlaceholder = isEs ? "Deja un comentario..." : "Leave a comment...";
  const ratingHint = isEs ? "Tu opinion ayuda a mejorar el proximo export." : "Your feedback helps improve the next export.";
  const ratingMissing = isEs ? "Elegí una cantidad de estrellas." : "Choose a star rating.";
  const ratingSaving = isEs ? "Enviando..." : "Sending...";
  const ratingThanks = isEs ? "Gracias por el feedback." : "Thanks for the feedback.";
  const ratingError = isEs ? "No se pudo enviar. Probá de nuevo." : "Could not send. Try again.";
  const encoded = encodeURIComponent(shareText);
  const iconStyle = 'width:18px;height:18px;display:block;flex:0 0 auto';
  const btnStyle = 'display:flex;align-items:center;justify-content:center;gap:6px;text-align:center;text-decoration:none;border-radius:9px;padding:9px 12px;font-family:var(--font,DM Sans,system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif);font-size:12px;font-weight:500;line-height:1;cursor:pointer;border:0';
  const whatsIcon = `<svg viewBox="0 0 32 32" aria-hidden="true" style="${iconStyle}"><path fill="currentColor" d="M16 3.5A12.4 12.4 0 0 0 5.3 22.2L4 28l5.9-1.3A12.4 12.4 0 1 0 16 3.5Zm0 2.3a10.1 10.1 0 1 1-5.2 18.8l-.5-.3-3.4.8.8-3.3-.3-.5A10.1 10.1 0 0 1 16 5.8Zm-4.1 5.1c-.2 0-.5 0-.7.3-.3.3-1 1-1 2.4s1 2.8 1.2 3c.1.2 2 3.2 5 4.3 2.4.9 3 .7 3.5.6.6-.1 1.8-.7 2-1.4.3-.7.3-1.3.2-1.4-.1-.2-.3-.2-.7-.4l-2-.9c-.3-.1-.6-.2-.8.2l-.9 1.1c-.2.3-.4.3-.8.1-.3-.2-1.4-.5-2.7-1.7-1-1-1.7-2.1-1.9-2.4-.2-.4 0-.5.1-.7l.5-.6c.1-.2.2-.4.3-.6.1-.2 0-.4 0-.6l-.9-2c-.2-.5-.5-.5-.8-.5h-.6Z"/></svg>`;
  const mailIcon = `<svg viewBox="0 0 24 24" aria-hidden="true" style="${iconStyle}"><path fill="currentColor" d="M3.5 5h17A1.5 1.5 0 0 1 22 6.5v11A1.5 1.5 0 0 1 20.5 19h-17A1.5 1.5 0 0 1 2 17.5v-11A1.5 1.5 0 0 1 3.5 5Zm.8 2 7.2 5.4c.3.2.7.2 1 0L19.7 7H4.3Zm15.7 1.8-6.3 4.7a2.8 2.8 0 0 1-3.4 0L4 8.8V17h16V8.8Z"/></svg>`;
  const copyIcon = `<svg viewBox="0 0 24 24" aria-hidden="true" style="${iconStyle}"><path fill="currentColor" d="M8 7.5A2.5 2.5 0 0 1 10.5 5h7A2.5 2.5 0 0 1 20 7.5v7A2.5 2.5 0 0 1 17.5 17h-7A2.5 2.5 0 0 1 8 14.5v-7Zm2.5-.5a.5.5 0 0 0-.5.5v7c0 .3.2.5.5.5h7c.3 0 .5-.2.5-.5v-7a.5.5 0 0 0-.5-.5h-7ZM4 10.5A2.5 2.5 0 0 1 6.5 8H7v2h-.5a.5.5 0 0 0-.5.5v7c0 .3.2.5.5.5h7c.3 0 .5-.2.5-.5V17h2v.5a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 4 17.5v-7Z"/></svg>`;
  const instagramIcon = `<svg viewBox="0 0 24 24" aria-hidden="true" style="${iconStyle}"><path fill="currentColor" d="M7.8 2h8.4A5.8 5.8 0 0 1 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8A5.8 5.8 0 0 1 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2Zm0 2A3.8 3.8 0 0 0 4 7.8v8.4A3.8 3.8 0 0 0 7.8 20h8.4a3.8 3.8 0 0 0 3.8-3.8V7.8A3.8 3.8 0 0 0 16.2 4H7.8ZM12 7.3a4.7 4.7 0 1 1 0 9.4 4.7 4.7 0 0 1 0-9.4Zm0 2a2.7 2.7 0 1 0 0 5.4 2.7 2.7 0 0 0 0-5.4Zm5-2.8a1.1 1.1 0 1 1 0 2.2 1.1 1.1 0 0 1 0-2.2Z"/></svg>`;
  document.body.insertAdjacentHTML("beforeend", `
    <div id="odPostExportShare" style="position:fixed;inset:0;z-index:999999;background:rgba(0,0,0,.42);display:flex;align-items:center;justify-content:center;padding:18px;font-family:var(--font,'DM Sans',system-ui,-apple-system,'Segoe UI',Roboto,Arial,sans-serif)">
      <div style="width:min(430px,100%);background:#fff;color:#111;border-radius:12px;box-shadow:0 24px 70px rgba(0,0,0,.3);padding:22px">
        <div style="display:flex;justify-content:space-between;gap:12px;align-items:start">
          <div>
            <div style="font-size:20px;font-weight:800;letter-spacing:-.03em">${title}</div>
            <div style="font-size:13px;line-height:1.45;color:#666;margin-top:6px">${text}</div>
          </div>
          <button id="odPostExportClose" type="button" style="border:0;background:#f0f0f0;border-radius:8px;width:30px;height:30px;cursor:pointer;font-size:16px">x</button>
        </div>
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-top:18px">
          <a href="https://wa.me/?text=${encoded}" target="_blank" rel="noopener noreferrer" style="${btnStyle};background:#22c55e;color:#fff">${whatsIcon}<span>WhatsApp</span></a>
          <a href="mailto:?subject=${encodeURIComponent('OpenDraw')}&body=${encoded}" style="${btnStyle};background:#111;color:#fff">${mailIcon}<span>Email</span></a>
          <button id="odPostExportInstagram" type="button" style="${btnStyle};background:linear-gradient(135deg,#833ab4,#fd1d1d,#fcb045);color:#fff">${instagramIcon}<span>Instagram</span></button>
          <button id="odPostExportCopy" type="button" style="${btnStyle};border:1px solid #ddd;background:#fafafa;color:#111">${copyIcon}<span>Copy link</span></button>
        </div>
        <div style="border-top:1px solid #eee;margin-top:18px;padding-top:16px">
          <div style="font-size:14px;font-weight:800;color:#111">${ratingTitle}</div>
          <div id="odPostExportStars" style="display:flex;gap:3px;margin-top:8px" aria-label="${ratingTitle}">
            ${[1, 2, 3, 4, 5].map(n => `<button type="button" data-stars="${n}" aria-label="${n} stars" style="border:0;background:transparent;color:#d8d8d8;font-size:25px;line-height:1;cursor:pointer;padding:0 2px;font-family:Arial,sans-serif">&#9733;</button>`).join("")}
          </div>
          <textarea id="odPostExportComment" rows="3" placeholder="${commentPlaceholder}" style="box-sizing:border-box;width:100%;margin-top:10px;border:1px solid #ddd;border-radius:9px;padding:10px;font-family:var(--font,'DM Sans',system-ui,-apple-system,'Segoe UI',Roboto,Arial,sans-serif);font-size:13px;line-height:1.35;resize:vertical"></textarea>
          <button id="odPostExportRatingSend" type="button" style="${btnStyle};width:100%;margin-top:8px;background:#111;color:#fff">${isEs ? "Enviar rating" : "Send rating"}</button>
          <div id="odPostExportRatingStatus" style="min-height:16px;margin-top:7px;font-size:12px;color:#777">${ratingHint}</div>
        </div>
      </div>
    </div>`);
  const root = document.getElementById("odPostExportShare");
  const close = () => root?.remove();
  document.getElementById("odPostExportClose")?.addEventListener("click", close);
  root?.addEventListener("click", (e) => { if (e.target === root) close(); });
  document.getElementById("odPostExportInstagram")?.addEventListener("click", async () => {
    try { await navigator.clipboard.writeText(shareText); } catch {}
    window.open("https://www.instagram.com/", "_blank", "noopener,noreferrer");
  });
  document.getElementById("odPostExportCopy")?.addEventListener("click", async () => {
    try {
      await navigator.clipboard.writeText(shareText);
      document.getElementById("odPostExportCopy").innerHTML = `${copyIcon}<span>${isEs ? "Link copiado" : "Link copied"}</span>`;
    } catch {
      window.prompt(isEs ? "Copia este texto:" : "Copy this text:", shareText);
    }
  });
  let selectedStars = 0;
  const starButtons = Array.from(root?.querySelectorAll("[data-stars]") || []);
  const paintStars = () => {
    starButtons.forEach(btn => {
      const value = Number(btn.dataset.stars) || 0;
      btn.style.color = value <= selectedStars ? "#f5a623" : "#d8d8d8";
    });
  };
  starButtons.forEach(btn => {
    btn.addEventListener("click", () => {
      selectedStars = Number(btn.dataset.stars) || 0;
      paintStars();
    });
  });
  paintStars();
  document.getElementById("odPostExportRatingSend")?.addEventListener("click", async () => {
    const status = document.getElementById("odPostExportRatingStatus");
    const send = document.getElementById("odPostExportRatingSend");
    if (!selectedStars) {
      if (status) status.textContent = ratingMissing;
      return;
    }
    if (status) status.textContent = ratingSaving;
    if (send) send.disabled = true;
    try {
      const comment = document.getElementById("odPostExportComment")?.value?.trim() || "";
      await saveEditorPostExportFeedback({
        stars: selectedStars,
        comment,
        lang: isEs ? "es" : "en"
      });
      if (status) status.textContent = ratingThanks;
    } catch (err) {
      console.warn("post export feedback:", err);
      if (status) status.textContent = ratingError;
      if (send) send.disabled = false;
    }
  });
}


async function exportTitleAndFramesToPDF() {
  const jsPDF = window.jspdf?.jsPDF || window.jsPDF;

  const prev = state.isExporting;
  state.isExporting = true;
  renderAll();

  try {
    if (!jsPDF) { alert("jsPDF no está cargado."); return; }

const base = (window.od_currentPlayName || document.getElementById("playName")?.value || "Untitled play").trim();
const title = `${base} · OpenDraw Play`;



    // ✅ usar el frameHasContent del renderer (misma lógica que playbook export)
    const odplayForExport = odBuildOdplay();
    const exportTitle = String(odplayForExport?.title || window.od_currentPlayName || "Untitled play").trim() || "Untitled play";
    const framesAllForExport = Array.isArray(odplayForExport?.frames) ? odplayForExport.frames : [];
    const hasContent = frameHasContentRenderer;

    const usedIdx = framesAllForExport
      .map((f, i) => ({ f, i }))
      .filter(({ f }) => hasContent(f));

    if (!usedIdx.length) { alert("No hay frames utilizados para exportar."); return; }

    // ✅ Canvas offscreen “base” como playbook export (consistencia total)
    const baseCanvasW = 1400;
    const baseCanvasH = 1300;
    const off = document.createElement("canvas");
    off.width = baseCanvasW;
    off.height = baseCanvasH;

    await initSharedRenderer();

    const pdf = new jsPDF({ unit: "pt", format: "a4", orientation: "portrait" });
    const pageW = pdf.internal.pageSize.getWidth();
    const pageH = pdf.internal.pageSize.getHeight();

    const marginX = 44;
    const marginTop = 40;
    const marginBottom = 62;
    const cols = 3;
    const rowsMax = 3;
    const gapX = 16;
    const headerTitleH = 28;
    const headerSubH = 16;
    const headerGapAfter = 14;
    const gridTop = marginTop + headerTitleH + headerSubH + headerGapAfter;
    const gridW = pageW - marginX * 2;
    const slotW = (gridW - gapX * (cols - 1)) / cols;
    const frameRatio = baseCanvasH / baseCanvasW;
    const capH = 12;
    const descH = 10;
    const blockGapY = 8;
    const gridHAvail = pageH - marginBottom - gridTop;
    const rowH = (gridHAvail - (rowsMax - 1) * blockGapY) / rowsMax;
    const frameBoxH = Math.max(40, rowH - capH - descH);
    const perPage = cols * rowsMax;
    const wantOBExport = odplayForExport?.courtMode === "ob";
    const courtScaleExport = (typeof odplayForExport?.courtScale === "number" && isFinite(odplayForExport.courtScale))
      ? odplayForExport.courtScale
      : (wantOBExport ? 0.83 : 1.0);
    const brandLogoDataUrl = await loadBrandLogoDataUrl();
    const brandFooterLead = "Made with OpenDraw - create yours at";
    const brandFooterUrl = "opendraw.pro";

    const drawBrandFooter = () => {
      const y = pageH - 38;
      const bandH = 26;
      const logoSize = 18;
      pdf.setFillColor(255, 248, 213);
      pdf.setDrawColor(240, 200, 60);
      pdf.setLineWidth(0.6);
      if (typeof pdf.roundedRect === "function") {
        pdf.roundedRect(marginX, y, pageW - marginX * 2, bandH, 5, 5, "FD");
      } else {
        pdf.rect(marginX, y, pageW - marginX * 2, bandH, "FD");
      }

      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(9.5);
      const leadW = pdf.getTextWidth(brandFooterLead);
      pdf.setFontSize(10.5);
      const urlW = pdf.getTextWidth(brandFooterUrl);
      const gap = 4;
      const logoGap = brandLogoDataUrl ? 7 : 0;
      const totalW = (brandLogoDataUrl ? logoSize + logoGap : 0) + leadW + gap + urlW;
      let x = (pageW - totalW) / 2;

      if (brandLogoDataUrl) {
        pdf.addImage(brandLogoDataUrl, "PNG", x, y + 4, logoSize, logoSize);
        x += logoSize + logoGap;
      }

      const textY = y + 16.5;
      pdf.setTextColor(20, 20, 20);
      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(9.5);
      pdf.text(brandFooterLead, x, textY);
      x += leadW + gap;

      pdf.setTextColor(213, 70, 0);
      pdf.setFontSize(10.5);
      pdf.text(brandFooterUrl, x, textY);
      pdf.setDrawColor(213, 70, 0);
      pdf.setLineWidth(0.8);
      pdf.line(x, textY + 1.8, x + urlW, textY + 1.8);
      if (typeof pdf.link === "function") {
        pdf.link(x - 1, textY - 10, urlW + 2, 13, { url: "https://www.opendraw.pro" });
      }
      pdf.setTextColor(0, 0, 0);
    };

    const drawHeader = () => {
      pdf.setTextColor(0, 0, 0);
pdf.setFont("helvetica", "bold");
pdf.setFontSize(24);

pdf.text(
  exportTitle,
  pageW / 2,            // eje X centrado
  marginTop + 22,
  { align: "center" }   // ✅ alineación
);



      drawBrandFooter();
    };

    drawHeader();

    // ✅ render real con od_renderer (NO screenshot del canvas UI)
    for (let k = 0; k < usedIdx.length; k++) {
      const { f, i } = usedIdx[k];

      if (k > 0 && k % perPage === 0) {
        pdf.addPage();
        drawHeader();
      }
const wantOB = wantOBExport;

// guardar previos
const prevMode  = state.courtMode;
const prevScale = state.courtScale;
const prevZoom  = state.zoom;
const prevStroke = state.strokeWidth;
if(false && wantOB) state.strokeWidth = prevStroke * 1.35;

await renderFrameToCanvas(f, off, {
  zoom: 3,
  courtMode: wantOBExport ? "ob" : "set",
  courtScale: courtScaleExport,
  isExporting: true,
});

state.strokeWidth = prevStroke;

// setear SOLO para export
state.courtMode  = wantOB ? "ob" : "set";
state.courtScale = courtScaleExport;
state.zoom       = 3;                 // ✅ recupera el “zoom estético” de arrows

// Rendered above with the same shared renderer used by Organizer exports.

// restaurar
state.courtMode  = prevMode;
state.courtScale = prevScale;
state.zoom       = prevZoom;





      const dataURL = off.toDataURL("image/jpeg", 0.92);

      const idx = k % perPage;
      const r = Math.floor(idx / cols);
      const col = idx % cols;

      const cellX = marginX + col * (slotW + gapX);
      const cellY = gridTop + r * (rowH + blockGapY);

      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(10);
      pdf.setTextColor(0, 0, 0);
      pdf.text(exportTitle.slice(0, 26), cellX, cellY + capH - 3);

      pdf.setFont("helvetica", "normal");
      pdf.setFontSize(9);
      pdf.text(`#${i + 1}`, cellX + slotW, cellY + capH - 3, { align: "right" });

      const maxW = slotW;
const maxH = frameBoxH;


      let imgW = maxW;
      let imgH = imgW * frameRatio;
      if (imgH > maxH) { imgH = maxH; imgW = imgH / frameRatio; }

      const imgX = cellX + (slotW - imgW) / 2;
      const imgY = cellY + capH;

      pdf.addImage(dataURL, "JPEG", imgX, imgY, imgW, imgH);


// -------- frame description (hint, pegado abajo)
const desc = String(f.desc || "").trim();


if (desc) {
  pdf.setFont("helvetica", "normal");
  pdf.setFontSize(8);
  pdf.setTextColor(40, 40, 40);

  const textX = cellX;
  const textY = imgY + imgH + 10;   // donde lo venías poniendo

  pdf.text(pdf.splitTextToSize(desc, slotW).slice(0, 2), textX, textY);
}


    }

    const safe = exportTitle.replace(/[\\/:*?"<>|]/g, "").slice(0, 60) || "opendraw";
    pdf.save(`${safe}.pdf`);
    showPostExportShareCTA();
  } finally {
    state.isExporting = prev;
    renderAll();
  }
}



// ---------- Controls wiring
if(strokeWidth && strokeWidthVal){
  strokeWidth.addEventListener("input", ()=>{
    state.strokeWidth = Number(strokeWidth.value);
    strokeWidthVal.textContent = String(state.strokeWidth);
    renderAll();
  });
}

if(gridToggle){
  gridToggle.addEventListener("change", ()=>{
    state.gridOn = gridToggle.checked;
    renderAll();
  });
}

if(snapOnEl){
  snapOnEl.addEventListener("change", ()=>{
    state.snapOn = snapOnEl.checked;
  });
}

if(zoomSel){
  zoomSel.addEventListener("change", ()=>{
    state.zoom = Number(zoomSel.value) / 100;
    renderAll();
  });
}

// NEW: Zoom +/- buttons (optional)
function applyZoom(newZoom){
  state.zoom = clamp(newZoom, 0.5, 1.25);
  if (zoomSel) zoomSel.value = String(Math.round(state.zoom * 100));
  renderAll();
  setStatus(`Zoom: ${Math.round(state.zoom*100)}%`, null);
}
if (zoomInBtn)  zoomInBtn.addEventListener("click", ()=> applyZoom(state.zoom + 0.05));
if (zoomOutBtn) zoomOutBtn.addEventListener("click", ()=> applyZoom(state.zoom - 0.05));

$$(".toolItem").forEach(btn=>{
  btn.addEventListener("click", ()=>{
    // tool on (non-select) stops stamping
    if(btn.dataset.tool !== "select"){
      state.selectedIcon = null;
      $$(".iconBtn").forEach(b=>{ if(b.dataset.icon) b.classList.remove("active"); });
    }
    setTool(btn.dataset.tool);
  });
});

if(undoBtn){
  undoBtn.addEventListener("click", ()=>{
    const f = getSelectedFrame();
    if(!f) return;
    undoFrame(f);
    renderAll();
    setStatus("Undo", null);
  });
}

if(addFrameBtn){
  addFrameBtn.addEventListener("click", ()=>{
    const f = newFrame(`Frame ${state.frames.length+1}`);
    snapshotFrame(f);
    state.frames.push(f);
    renderAll();
    selectFrame(f.id);
  });
}

if (dupFrameBtn) {
  dupFrameBtn.addEventListener("click", () => {
    console.log("[dup] clicked, selectedFrameId=", state.selectedFrameId, "frames=", state.frames.length);
    const src = getSelectedFrame();
    console.log("[dup] src=", src);
    if (!src) return;

    const f = duplicateFrame(src);

    const idx = state.frames.findIndex(fr => fr.id === src.id);
    const insertAt = idx >= 0 ? idx + 1 : state.frames.length;
    state.frames.splice(insertAt, 0, f);
    console.log("[dup] after splice frames=", state.frames.length, "insertAt=", insertAt);

    renderAll();
    selectFrame(f.id);
  });
}
if (smartFrameBtn) {
  smartFrameBtn.addEventListener("click", () => {
    applySmartToNextFrame();
  });
}

if (smartFramePillBtn) {
  smartFramePillBtn.addEventListener("click", () => {
    applySmartToNextFrame();
  });
}




if(clearFrameBtn){
  clearFrameBtn.addEventListener("click", ()=>{
    const f = getSelectedFrame();
    if(!f) return;
    if(!confirm("Clear selected frame?")) return;
    clearFrame(f);
    renderAll();
  });
}
const addBallBtn = document.getElementById("addBallBtn");
if(addBallBtn){
  addBallBtn.addEventListener("click", () => addBallToSelected());
}

(function wireCourtPopup(){
  const courtBtn = document.getElementById("courtBtn");
  const courtPopup = document.getElementById("courtPopup");
  if(!courtBtn || !courtPopup) return;

  let isOpen = false;

  function openPopup(){
    courtPopup.classList.remove("hidden");
    courtPopup.style.display = "block";
    courtPopup.style.zIndex = "99999";
    isOpen = true;
  }

  function closePopup(){
    courtPopup.classList.add("hidden");
    isOpen = false;
  }

  courtBtn.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();   // 🔑 CLAVE
    if(isOpen) closePopup();
    else openPopup();
  });

  // click afuera → cerrar
  document.addEventListener("mousedown", (e) => {
    if(!isOpen) return;
    if(courtPopup.contains(e.target)) return;
    if(courtBtn.contains(e.target)) return;
    closePopup();
  });
})();
(function wireCourtRadios(){
  const courtPopup = document.getElementById("courtPopup");
  if(!courtPopup) return;

  courtPopup.addEventListener("change", (e) => {
    const t = e.target;
    if(t.name !== "courtType") return;

    // "set" | "ob"
    setCourtMode(t.value);
  });
})();

// Keyboard
document.addEventListener("keydown", (e)=>{
  const key = e.key.toLowerCase();

  if((e.ctrlKey||e.metaKey) && key==="z"){
    e.preventDefault();
    if(undoBtn) undoBtn.click();
    return;
  }

  if(key === "v"){
    state.selectedIcon = null;
    $$(".iconBtn").forEach(b=>{ if(b.dataset.icon) b.classList.remove("active"); });
    setTool("select");
    return;
  }

  if(key === "a"){
    state.selectedIcon = null;
    $$(".iconBtn").forEach(b=>{ if(b.dataset.icon) b.classList.remove("active"); });
    setTool("arrow");
    return;
  }
  // Arrow keys: move selected object
  if (e.key === "ArrowLeft" || e.key === "ArrowRight" || e.key === "ArrowUp" || e.key === "ArrowDown") {
    // si estás escribiendo en un input, no secuestres las flechas (cursor)
    if (isTypingInField()) return;

    e.preventDefault();
    e.stopPropagation();

    // Paso base en px (SHIFT = “turbo”)
    const base = e.shiftKey ? 10 : 2;

    // 🔑 Multiplico por zoom para que el movimiento “en mundo” sea constante:
    // canvas.width = FRAME_W * zoom, entonces dxNorm = (base*zoom)/(FRAME_W*zoom) = base/FRAME_W
    const step = base * (state.zoom || 1);

    const dx = (e.key === "ArrowLeft") ? -step : (e.key === "ArrowRight") ? step : 0;
    const dy = (e.key === "ArrowUp")   ? -step : (e.key === "ArrowDown")  ? step : 0;

    nudgeSelectedObject(dx, dy);
    return;
  }

  if(e.key === "Delete" || e.key === "Backspace"){
    if(e.key === "Backspace" && isTypingInField()) return;
    const did = deleteSelectedObject();
    if(did){
      e.preventDefault();
      e.stopPropagation();
    }
    return;
  }

  if(e.key === "Escape"){
    state.selectedIcon = null;
    $$(".iconBtn").forEach(b=>{ if(b.dataset.icon) b.classList.remove("active"); });
    setStatus("Stamp off", "Tool: Select");
  }
}, true);
// ================================
// Organizer integration (Firestore)
// ================================
const OD_FB_CONFIG_KEY = "od_firebase_config";
const OD_EDITOR_PLAYID_KEY = "od_editor_playId";

// Safe getters
function odGetFirebaseConfig(){
  return window.__OD_FIREBASE_CONFIG__ || null;
}
function odGetCurrentPlayId(){ return localStorage.getItem(OD_EDITOR_PLAYID_KEY) || ""; }
function odSetCurrentPlayId(id){ localStorage.setItem(OD_EDITOR_PLAYID_KEY, id); }

// This expects Firebase "compat" global (`firebase`) already loaded somewhere.
// If it's not present, button will be disabled gracefully.
function odGetFirebase(){
  return window.firebase || null;
}
function odEnsureFirebaseCompatInited(){
  const fb = window.firebase;
  if (!fb) throw new Error("Firebase compat no cargó (window.firebase).");

  // Si ya hay app, listo
  if (fb.apps && fb.apps.length) return;

  // Tomar config de localStorage como en Organizer
let firebaseConfig = window.__OD_FIREBASE_CONFIG__ || null;

if (!firebaseConfig) {
  throw new Error("Missing window.__OD_FIREBASE_CONFIG__");
}

  fb.initializeApp(firebaseConfig);
if (fb.appCheck) {
  fb.appCheck().activate("6LceeogsAAAAAMVzaOl90c2Tix-VoZA1mN6oR6p6", true);
}
}
async function loadEditorTeams(uid) {
  const select = document.getElementById("editorTeamSelect");
  if (!select) return;
  // ✅ Si ya cargamos teams, no hacer nada
  if (EditorCache.teams.length > 0) {
    return;
  }
  select.innerHTML = `<option value="">Team</option>`;

  const db = window.firebase.firestore();
  const snap = await db
    .collection("users")
    .doc(uid)
    .collection("teams")
    .orderBy("createdAt", "asc")
    .get();

  snap.forEach(d => {
    const opt = document.createElement("option");
    opt.value = d.id;
    opt.textContent = d.data().name;
    select.appendChild(opt);
  });
}


async function odEnsureAuthedOrRedirect(){
  const fb = odGetFirebase();
  const cfg = odGetFirebaseConfig();
  if (!fb || !cfg) return { ok:false, reason:"firebase_missing" };

  if (!fb.apps || !fb.apps.length) fb.initializeApp(cfg);

  return new Promise((resolve)=>{
    fb.auth().onAuthStateChanged((user)=>{
      if (!user){
        window.location.href = "index.html";
        resolve({ ok:false, reason:"no_session" });
      } else {
        resolve({ ok:true, user });
      }
    });
  });
}
async function initSharedRenderer(){
  setRendererPaths({
    courtSrc: "./court.svg",
    iconBase: "./icons/",
    iconRenderScale: 2.0
  });
  await ensureAssetsLoaded();
}


// ================================
// Editor Topbar (Organizer-like)
// ================================
function odWireEditorTopbar(){
  const bar = document.getElementById("authTopbar");
  if (!bar) return;

  const who = document.getElementById("authWhoName");
  const btnOut = document.getElementById("btnLogoutTop");
  const btnOrg = document.getElementById("btnGoOrganizer");

  // link (por si querés forzar navegación con JS)
  if (btnOrg && !btnOrg.dataset.wired){
    btnOrg.dataset.wired = "1";
    btnOrg.addEventListener("click", (e)=>{
      // dejalo como link normal, pero esto asegura consistencia
      e.preventDefault();
      window.location.href = "./organizer.html2";
    });
  }

  // auth gate
  odEnsureAuthedOrRedirect().then(({ ok, user }) => {
    if (!ok || !user) return;

    bar.style.display = "flex";
    if (who) who.textContent = user.displayName || user.email || "usuario";

    if (btnOut && !btnOut.dataset.wired){
      btnOut.dataset.wired = "1";
      btnOut.addEventListener("click", async ()=>{
        try{
          const fb = odGetFirebase();
          await fb.auth().signOut();
        } finally {
          window.location.href = "./index.html";
        }
      });
    }
  });
}


// ---------- ODPLAY (lightweight play format) ----------
// We store the play as a compact JSON string in Firestore field: odplay (plus notes).
// No PNGs. Preview/restore is done by re-rendering from objects onto court.svg.
const ODPLAY_VERSION = 1;

const OD_RUNTIME_KEYS = new Set([
  "canvas","ctx","canvasEl","_ctx","_canvas",
  "selected","isSelected","_selected","hover","hovered","_hover",
  "handles","_handles","bbox","_bbox","_path","_cache",
  "imgEl","image","_img","_image",
  "draft","_draft","tmp","_tmp"
]);

function odDeepCloneSansRuntime(obj){
  try{
    return JSON.parse(JSON.stringify(obj, (k,v)=> OD_RUNTIME_KEYS.has(k) ? undefined : v));
  } catch (e){
    // as a fallback, return a shallow clone
    try{ return { ...(obj||{}) }; } catch { return {}; }
  }
}

function odBuildOdplay(){
const title = (
  document.getElementById("playName")?.value ||
  window.od_currentPlayName ||
  "Untitled play"
).trim() || "Untitled play";
  const notes = (document.getElementById("playNotes")?.value || "").trim();

const frames = (state.frames || []).map((fr, i)=>({
  label: fr?.label || `Frame ${i+1}`,
  desc: (typeof fr?.desc === "string") ? fr.desc : "",   // ✅ NEW
  objects: (fr?.objects || []).map(odDeepCloneSansRuntime)
}));



  return {
    v: ODPLAY_VERSION,
    title,
    notes,
    court: "court.svg",

    // ✅ NUEVO: el modo es parte de la jugada
    courtMode: (state.courtMode === "ob") ? "ob" : "set",
    courtScale: (typeof state.courtScale === "number") ? state.courtScale : 0.83,

    createdAtMs: Date.now(),
    frames
  };
}

function odApplyOdplayToEditor(odplay){
  if (!odplay || !Array.isArray(odplay.frames)) return;

  // Ensure enough frames exist
  const want = odplay.frames.length;
  while ((state.frames?.length || 0) < want){
    state.frames.push(newFrame(`Frame ${state.frames.length + 1}`));
  }
  // If we have more frames than needed, keep extras but clear them (MVP-safe)
 (state.frames || []).forEach((fr, idx) => {
  const src = odplay.frames[idx];

  if (!src) {
    fr.label = fr.label || `Frame ${idx+1}`;
    fr.objects = [];
    fr.desc = "";                // ✅ IMPORTANTE: evitar undefined
    snapshotFrame(fr);
    return;
  }

fr.label = src.label || `Frame ${idx+1}`;
fr.objects = Array.isArray(src.objects) ? src.objects.map(odDeepCloneSansRuntime) : [];
fr.desc = (typeof src.desc === "string") ? src.desc : "";

/* resetear historial al estado cargado */
fr.history = [JSON.stringify(fr.objects)];
fr.historyIdx = 0;
});
  // UI inputs
  const nameEl = document.getElementById("playName");
  if (nameEl && odplay.title) nameEl.value = odplay.title;
  const notesEl = document.getElementById("playNotes");
  if (notesEl && typeof odplay.notes === "string") notesEl.value = odplay.notes;
  // ✅ NUEVO: al abrir una jugada, el editor adopta su modo
  state.courtMode  = (odplay.courtMode === "ob") ? "ob" : "set";
  state.courtScale = (typeof odplay.courtScale === "number") ? odplay.courtScale : 0.83;
if (odplay?.title) window.od_currentPlayName = String(odplay.title);

  // (opcional pero recomendado) sync UI si tenés radios de Court
  document.querySelectorAll('input[name="courtType"]').forEach(r => {
    r.checked = (r.value === state.courtMode);
  });

  renderAll();
}

async function odTryLoadPlayFromOrganizer(){
  // Organizer will send you to: editor.html?playId=XXXX
  const params = new URLSearchParams(window.location.search || "");
  const playIdFromUrl = params.get("playId") || "";
  const playId = playIdFromUrl || odGetCurrentPlayId();

  if (!playId){
    odRedirectOrganizer();
    return;
  }

  // 🔒 PLAY ID CANÓNICO DEL EDITOR
  window.od_activePlayId = playId;

  odWireEditorTopbar();

  // persist so refresh keeps it
  if (playIdFromUrl) odSetCurrentPlayId(playIdFromUrl);

  const auth = await odEnsureAuthedOrRedirect();
  if (!auth.ok) return;

  const fb = odGetFirebase();
  if (!fb) return;

  try{
    const db = fb.firestore();
    const snap = await db
      .collection("users")
      .doc(auth.user.uid)
      .collection("plays")
      .doc(playId)
      .get();

    if (!snap.exists){
      try { localStorage.removeItem(OD_EDITOR_PLAYID_KEY); } catch {}
      odRedirectOrganizer();
      return;
    }

    const data = snap.data() || {};

    // ---- CONTEXTO ----
    window.od_currentTeamId   = data.teamId   || "";
    window.od_currentSeasonId = data.seasonId || "";
    window.od_currentPlayName = data.name     || "";

    // ---- APLICAR PLAY ----
    if (data.odplay && typeof data.odplay === "object") {
      odApplyOdplayToEditor(data.odplay);
    } else {
      const odplayStr = data.odplayJson || data.odplay || data.odPlay || "";
      if (odplayStr) {
        const odplay = JSON.parse(odplayStr);
        odApplyOdplayToEditor(odplay);
      } else {
        // fallback mínimo
        const nameEl = document.getElementById("playName");
        if (nameEl) nameEl.value = data.name || "";
        renderAll();
      }
    }

    setStatus(`Loaded ✓ (${playId})`, "Tool: Select");
  } catch (e){
    setStatus("Could not load play (see console).", null);
  }
}


async function odLoadTeams(db, uid){
  const snap = await db.collection("users").doc(uid).collection("teams")
    .orderBy("createdAt","asc").get();
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));

}

async function odLoadSeasons(db, uid, teamId){
  const snap = await db.collection("users").doc(uid).collection("teams").doc(teamId)
    .collection("seasons").orderBy("createdAt","asc").get();
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));


}

async function odCreateTeam(db, uid, name){
  const now = new Date();
  const ref = db.collection("users").doc(uid).collection("teams").doc();
  await ref.set({ ...payload, createdAt: now, updatedAt: now });

  return ref.id;
}

async function odCreateSeason(db, uid, teamId, name){
  const now = new Date();
  const ref = db.collection("users").doc(uid).collection("teams").doc(teamId).collection("seasons").doc();
  await ref.set({ ...payload, createdAt: now, updatedAt: now });

  return ref.id;
}

async function odUpsertPlay(db, uid, payload){
  const now = new Date();
  let playId = odGetCurrentPlayId();

  if (!playId){
    const ref = db.collection("users").doc(uid).collection("plays").doc();
    playId = ref.id;
    await ref.set({ ...payload, createdAt: now, updatedAt: now });

    odSetCurrentPlayId(playId);
    return playId;
  } else {
    const ref = db.collection("users").doc(uid).collection("plays").doc(playId);
    await ref.set({ ...payload, updatedAt: now }, { merge: true });

    return playId;
  }
}
function odHasRealContent(odplayObj){
  const frames = odplayObj?.frames || [];
  return frames.some(f => Array.isArray(f.objects) && f.objects.length > 0);
}

function odOneFrameOdplayFromTemplate(template){
  if (!template) return null;
  try{
    const odplay = typeof template.odplayJson === "string"
      ? JSON.parse(template.odplayJson)
      : template;
    const src = Array.isArray(odplay.frames) ? odplay.frames[0] : null;
    if (!src) return null;
    return {
      v: ODPLAY_VERSION,
      title: template.name || odplay.title || "Template",
      notes: "",
      court: "court.svg",
      courtMode: (odplay.courtMode === "ob") ? "ob" : "set",
      courtScale: (typeof odplay.courtScale === "number") ? odplay.courtScale : 0.83,
      frames: [{
        label: template.name || src.label || "Template",
        desc: typeof src.desc === "string" ? src.desc : "",
        objects: Array.isArray(src.objects) ? src.objects.map(odDeepCloneSansRuntime) : []
      }]
    };
  } catch {
    return null;
  }
}

function odApplyFrameTemplate(template){
  const odplay = odOneFrameOdplayFromTemplate(template);
  const src = odplay?.frames?.[0];
  const dst = getSelectedFrame?.() || state.frames?.[0];
  if (!src || !dst) return;

  dst.label = src.label || dst.label || "Frame 1";
  dst.desc = src.desc || "";
  dst.objects = Array.isArray(src.objects) ? src.objects.map(odDeepCloneSansRuntime) : [];
  state.courtMode = odplay.courtMode || state.courtMode || "set";
  state.courtScale = typeof odplay.courtScale === "number" ? odplay.courtScale : state.courtScale;
  state.selectedObjectId = null;
  snapshotFrame(dst);
  renderAll();
  selectFrame(dst.id);
  odAutosave("Template");
  setStatus(`Template: ${template.name || dst.label}`, null);
}

function odEnsureTemplatesMenu(){
  let menu = document.getElementById("odFrameTemplatesMenu");
  if (menu) return menu;

  const toolbar = document.querySelector(".toolbar");
  const courtBtn = document.getElementById("courtBtn");
  if (!toolbar || !courtBtn) return null;

  const wrap = document.createElement("div");
  wrap.className = "odTemplatesButtonWrap";
  wrap.innerHTML = `
    <button type="button" class="tbtn odTemplatesToggle" id="odTemplatesToggleBtn">
      Templates <span class="odTemplatesNew" id="odTemplatesNewHint">(new)</span>
    </button>
    <div class="odTemplatesMenu" id="odFrameTemplatesMenu" hidden>
      <div class="odTemplatesHead">
        <div>
          <div class="odTemplatesTitle">Templates</div>
          <div class="odTemplatesSub">Insertar en el frame seleccionado</div>
        </div>
        <button type="button" class="odTemplatesReload" id="odTemplatesReloadBtn" title="Reload templates">Reload</button>
      </div>
      <div class="odTemplatesStrip" id="odTemplatesStrip"></div>
    </div>
  `;
  courtBtn.insertAdjacentElement("afterend", wrap);

  const newHint = wrap.querySelector("#odTemplatesNewHint");
  const newUntil = Date.UTC(2026, 8, 18);
  if (newHint && Date.now() > newUntil) newHint.remove();

  const toggle = wrap.querySelector("#odTemplatesToggleBtn");
  menu = wrap.querySelector("#odFrameTemplatesMenu");
  toggle?.addEventListener("click", (event) => {
    event.preventDefault();
    event.stopPropagation();
    const opening = menu.hasAttribute("hidden");
    if (opening) {
      menu.removeAttribute("hidden");
      odLoadFrameTemplates();
    } else {
      menu.setAttribute("hidden", "");
    }
  });
  wrap.querySelector("#odTemplatesReloadBtn")?.addEventListener("click", (event) => {
    event.preventDefault();
    event.stopPropagation();
    odLoadFrameTemplates({ force: true });
  });
  document.addEventListener("click", (event) => {
    if (!wrap.contains(event.target)) menu?.setAttribute("hidden", "");
  });
  return menu;
}

async function odPaintTemplatePreview(template, canvas){
  const odplay = odOneFrameOdplayFromTemplate(template);
  const frame = odplay?.frames?.[0];
  if (!frame || !canvas) return;
  try {
    await renderFrameToCanvas(frame, canvas, {
      zoom: 0.55,
      courtMode: odplay.courtMode || "set",
      courtScale: odplay.courtScale,
      iconScale: 1.8,
      isExporting: true
    });
  } catch {}
}

async function odLoadFrameTemplates(opts = {}){
  if (OD_TEMPLATE_MODE) return;
  const menu = odEnsureTemplatesMenu();
  const strip = document.getElementById("odTemplatesStrip");
  if (!menu || !strip) return;
  if (strip.dataset.loaded === "1" && !opts.force) return;

  strip.dataset.loaded = "1";
  strip.innerHTML = `<div class="odTemplatesEmpty">Loading templates...</div>`;

  try{
    await initSharedRenderer();
    const resp = await fetch("/api/frame-templates", { method: "GET", cache: "no-store" });
    if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
    const data = await resp.json();
    const templates = Array.isArray(data.templates) ? data.templates : [];

    if (!templates.length){
      strip.innerHTML = `<div class="odTemplatesEmpty">No hay templates cargados todavia.</div>`;
      return;
    }

    strip.innerHTML = "";
    for (const template of templates){
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "odTemplateCard";
      btn.title = `Insert ${template.name}`;
      btn.innerHTML = `
        <canvas class="odTemplateCanvas" width="210" height="156"></canvas>
        <span class="odTemplateName"></span>
      `;
      btn.querySelector(".odTemplateName").textContent = template.name || "Template";
      btn.addEventListener("click", () => odApplyFrameTemplate(template));
      strip.appendChild(btn);
      odPaintTemplatePreview(template, btn.querySelector("canvas"));
    }
  } catch (error){
    console.warn("[templates] load failed", error);
    strip.innerHTML = `<div class="odTemplatesEmpty">No se pudieron cargar templates.</div>`;
  }
}

function odWireTemplateAdminUi(user){
  document.body.classList.add("odTemplateAdminMode");
  const sidebarActions = document.querySelector(".sidebarActions");
  sidebarActions?.querySelector("#addFrameBtn")?.setAttribute("disabled", "disabled");
  sidebarActions?.querySelector("#dupFrameBtn")?.setAttribute("disabled", "disabled");
  document.getElementById("smartFrameBtn")?.setAttribute("disabled", "disabled");
  document.getElementById("smartFramePillBtn")?.setAttribute("disabled", "disabled");
  document.getElementById("newPlayBtn")?.setAttribute("hidden", "");
  document.getElementById("renamePlayBtn")?.setAttribute("hidden", "");
  document.getElementById("editorTeamSelect")?.setAttribute("hidden", "");
  document.getElementById("editorSeasonSelect")?.setAttribute("hidden", "");
  document.getElementById("editorPlaySelect")?.setAttribute("hidden", "");

  let bar = document.getElementById("odTemplateAdminBar");
  if (!bar){
    bar = document.createElement("section");
    bar.id = "odTemplateAdminBar";
    bar.className = "odTemplateAdminBar";
    bar.innerHTML = `
      <div>
        <div class="odTemplatesTitle">Editor de frame predeterminado</div>
        <div class="odTemplatesSub">${user?.email || ""}</div>
      </div>
      <input id="odTemplateNameInput" class="odTemplateNameInput" type="text" maxlength="80" placeholder="Nombre: Horns, Stagger..." />
      <button id="odTemplateSaveBtn" class="tbtn" type="button">Save template</button>
    `;
    const main = document.querySelector(".main");
    const toolbar = document.querySelector(".toolbar");
    if (main && toolbar) main.insertBefore(bar, toolbar.nextSibling);
  }

  const input = document.getElementById("odTemplateNameInput");
  const saveBtn = document.getElementById("odTemplateSaveBtn");
  if (input && !input.value) input.value = "Horns";
  if (saveBtn && !saveBtn.dataset.wired){
    saveBtn.dataset.wired = "1";
    saveBtn.addEventListener("click", async () => {
      const name = (input?.value || "").trim();
      if (!name){
        alert("Ponle un nombre al template.");
        input?.focus();
        return;
      }
      const odplay = odBuildOdplay();
      odplay.title = name;
      odplay.frames = odplay.frames.slice(0, 1);
      odplay.frames[0].label = name;

      saveBtn.disabled = true;
      setStatus("Saving template...", null);
      try{
        const token = await user.getIdToken();
        const resp = await fetch("/api/admin-frame-template", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          },
          body: JSON.stringify({ name, odplay })
        });
        const data = await resp.json().catch(() => ({}));
        if (!resp.ok) throw new Error(data.error || `HTTP ${resp.status}`);
        setStatus(`Template saved: ${data.name || name}`, null);
      } catch (error){
        console.error("[templates] save failed", error);
        alert("No se pudo guardar el template: " + (error?.message || error));
        setStatus("Template save failed", null);
      } finally {
        saveBtn.disabled = false;
      }
    });
  }
}

async function odBootTemplateAdminMode(){
  const auth = await odEnsureAuthedOrRedirect();
  if (!auth.ok || !auth.user) return;
  const email = String(auth.user.email || "").toLowerCase().trim();
  if (email !== OD_TEMPLATE_ADMIN_EMAIL){
    alert("Este editor de templates esta reservado para el admin.");
    window.location.href = "./organizer.html";
    return;
  }

  odWireTemplateAdminUi(auth.user);
  state.frames = [newFrame("Horns")];
  state.frames.forEach(f => snapshotFrame(f));
  state.selectedObjectId = null;
  renderAll();
  selectFrame(state.frames[0].id);
  document.querySelector(".main")?.classList.remove("isLoading");
  setStatus("Template mode ready", "1 frame");
}

async function odSaveChanges(opts = {}){
  const auth = await odEnsureAuthedOrRedirect();
  if (!auth.ok) return;

  const playId = odGetPlayIdFromUrl() || odGetCurrentPlayId();
  if (!playId){
    odRedirectOrganizer();
    return;
  }

  const now = new Date();
const playName = (
  document.getElementById("playName")?.value ||
  window.od_currentPlayName ||
  ""
).trim() || "Untitled play";  const notesVal = "";

  const odplayObj = odBuildOdplay();
  const hasContent = odHasRealContent(odplayObj);

  const payload = {
    name: playName,
    notes: notesVal,
    odplayV: ODPLAY_VERSION,
    odplayJson: JSON.stringify(odplayObj),

    hasContent,
    status: hasContent ? "active" : "draft",
    updatedAt: now
  };

  const db = window.firebase.firestore();
  await db.collection("users").doc(auth.user.uid)
    .collection("plays").doc(playId)
    .set(payload, { merge: true });

  if (!opts.silent) setStatus("Saved changes ✓", null);
}


async function odSaveAsNew(){
  const auth = await odEnsureAuthedOrRedirect();
  if (!auth.ok) return;

  const now = new Date();
const playName = (
  document.getElementById("playName")?.value ||
  window.od_currentPlayName ||
  ""
).trim() || "Untitled play";
  const notesVal = "";

  const odplayObj = odBuildOdplay();
  const hasContent = odHasRealContent(odplayObj);

  // ⚠️ Importante: conservar teamId/seasonId del doc actual.
  // Para eso: guardalos cuando cargás el play (en odTryLoadPlayFromOrganizer)
  // como variables globales: window.od_currentTeamId / window.od_currentSeasonId

  const teamId = window.od_currentTeamId || "";
  const seasonId = window.od_currentSeasonId || "";

  const payload = {
    name: playName,
    notes: notesVal,
    teamId,
    seasonId,

    odplayV: ODPLAY_VERSION,
    odplayJson: JSON.stringify(odplayObj),

    hasContent,
    status: hasContent ? "active" : "draft",
    createdAt: now,
    updatedAt: now
  };

  const db = window.firebase.firestore();
  const ref = db.collection("users").doc(auth.user.uid).collection("plays").doc();
  await ref.set(payload);

  // Switch de riel: ahora este editor trabaja sobre el nuevo playId
  odSetCurrentPlayId(ref.id);
  window.history.replaceState(null, "", `./editor.html?playId=${encodeURIComponent(ref.id)}`);

  setStatus("Saved as new ✓", null);
}

function odShowAddToOrganizerPopup() {
  const dlg = document.getElementById("odOrganizerModal") || document.getElementById("addToOrganizerDialog");
  if (!dlg) return;
  if (typeof dlg.showModal === "function") dlg.showModal();
  else dlg.classList.add("open");
}
async function odCommitSaveAsNew(){
  const auth = await odEnsureAuthedOrRedirect();
  if (!auth.ok) return;

  const user = auth.user;

  // 1) name del modal
  const input = document.getElementById("odSaveAsNewName");
  const newName = (input?.value || "").trim() || "Untitled play";

  // 2) copiar team/season del play actual (se setean cuando cargás el doc)
  let teamId = window.od_currentTeamId || "";
  let seasonId = window.od_currentSeasonId || "";

  // 2.1 blindaje: si están vacíos, leer el doc actual
  const playId =
    new URLSearchParams(location.search).get("playId") ||
    localStorage.getItem("od_editor_playId");

  if ((!teamId || !seasonId) && playId){
    const snap = await window.firebase.firestore()
      .collection("users").doc(user.uid)
      .collection("plays").doc(playId)
      .get();

    if (snap.exists){
      const data = snap.data() || {};
      teamId = data.teamId || teamId;
      seasonId = data.seasonId || seasonId;
      window.od_currentTeamId = teamId;
      window.od_currentSeasonId = seasonId;
    }
  }

  // 3) exportar el estado actual del editor a odplayObj (ajusta si tu función se llama distinto)
  const odplayObj = (typeof odBuildOdplay === "function")
    ? odBuildOdplay()
    : { title: newName, notes: "", frames: [] };

  odplayObj.title = newName;

  // 4) crear doc nuevo
  const db = window.firebase.firestore();
  const ref = db.collection("users").doc(user.uid).collection("plays").doc();

  await ref.set({
    name: newName,
    notes: "",
    teamId,
    seasonId,

    odplayV: 1,
    odplayJson: JSON.stringify(odplayObj),

    status: "draft",
    hasContent: true,
    createdAt: new Date(),
    updatedAt: new Date(),
  });

  // 5) cambiar el carril al nuevo playId
  try { localStorage.setItem("od_editor_playId", ref.id); } catch {}
  history.replaceState(null, "", `./editor.html?playId=${encodeURIComponent(ref.id)}`);

  window.od_currentPlayName = newName;
  odCloseSaveAsNewModal();
  setStatus?.("Saved as new ✓");
}


// ---------- odAskModal — reemplaza prompt() que está bloqueado en algunos browsers

function odAskModal(message, defaultValue = "") {
  return new Promise((resolve) => {
    const overlay = document.createElement("div");
    overlay.style.cssText = "position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:99999;display:flex;align-items:center;justify-content:center";

    const box = document.createElement("div");
    box.style.cssText = "background:#1e1e2e;color:#e0e0f0;padding:24px 28px;border-radius:10px;min-width:320px;max-width:460px;width:90%;box-shadow:0 8px 32px rgba(0,0,0,.6);font-family:inherit";

    const label = document.createElement("div");
    label.textContent = message;
    label.style.cssText = "margin-bottom:12px;font-size:14px;opacity:.9";

    const input = document.createElement("input");
    input.type = "text";
    input.value = defaultValue;
    input.style.cssText = "width:100%;box-sizing:border-box;padding:8px 10px;border-radius:6px;border:1px solid #555;background:#2a2a3e;color:#fff;font-size:14px;outline:none";

    const btns = document.createElement("div");
    btns.style.cssText = "display:flex;justify-content:flex-end;gap:10px;margin-top:16px";

    const btnCancel = document.createElement("button");
    btnCancel.textContent = "Cancel";
    btnCancel.style.cssText = "padding:7px 16px;border-radius:6px;border:1px solid #555;background:transparent;color:#aaa;cursor:pointer;font-size:13px";

    const btnOk = document.createElement("button");
    btnOk.textContent = "OK";
    btnOk.style.cssText = "padding:7px 16px;border-radius:6px;border:none;background:#4a90d9;color:#fff;cursor:pointer;font-size:13px;font-weight:600";

    const finish = (val) => { document.body.removeChild(overlay); resolve(val); };

    btnCancel.addEventListener("click", () => finish(null));
    btnOk.addEventListener("click", () => finish(input.value.trim() || null));
    input.addEventListener("keydown", (e) => {
      if (e.key === "Enter") finish(input.value.trim() || null);
      if (e.key === "Escape") finish(null);
    });

    btns.appendChild(btnCancel);
    btns.appendChild(btnOk);
    box.appendChild(label);
    box.appendChild(input);
    box.appendChild(btns);
    overlay.appendChild(box);
    document.body.appendChild(overlay);

    setTimeout(() => { input.focus(); input.select(); }, 50);
  });
}

// ---------- Boot

async function boot(){
applyTranslations();
initAnimation({
  getFrames: () => state.frames,
  getTitle: () => window.od_currentPlayName || document.getElementById("playName")?.value || "OpenDraw",
  getCourt: () => ({ src: COURT_IMG_SRC, mode: state.courtMode, scale: state.courtScale }),
  tipForArrow: arrow => getArrowHeadTipNorm(arrow, FRAME_W, FRAME_H),
  onExported: details => !OD_TEMPLATE_MODE && recordAnimationExport({
    firebase: window.firebase, uid: window.currentUid,
    playId: window.od_activePlayId || odGetCurrentPlayId(), ...details
  })
});

function odInitTopbarCompat(){
  const fb = odGetFirebase();

  return initTopbar({
    subscribeAuth: (cb) => fb.auth().onAuthStateChanged(cb),
    logout: () => fb.auth().signOut(),
    onNoUser: () => { window.location.href = "./index.html"; },
    links: { organizerHref: "./organizer.html", editorHref: "./editor.html" },
    onHelp: () => {
      localStorage.removeItem('od_tour_editor_v1');
      startTour(getEditorTourSteps(), 'od_tour_editor_v1');
    }
  });
}
odEnsureFirebaseCompatInited();

const isMobile =
  window.matchMedia("(max-width: 900px)").matches ||
  window.matchMedia("(pointer: coarse)").matches;

if (!isMobile) {
  odInitTopbarCompat();
}


const playIdFromUrl = odGetPlayIdFromUrl();
const playId = playIdFromUrl || odGetCurrentPlayId();

if (!playId && !OD_TEMPLATE_MODE){
  odRedirectOrganizer();
  return;
}
const btnNewPlay   = document.getElementById("newPlayBtn");
const btnRenamePlay = document.getElementById("renamePlayBtn");

if (btnRenamePlay && !btnRenamePlay.dataset.wired) {
  btnRenamePlay.dataset.wired = "1";
  
  btnRenamePlay.addEventListener("click", async () => {
    try {
      const currentName = (
        document.getElementById("playName")?.value || 
        window.od_currentPlayName || 
        "Untitled play"
      ).trim();

      const newName = (await odAskModal("Rename play to:", currentName) || "").trim();

      if (!newName || newName === currentName) {
        if (statusLeft) statusLeft.textContent = newName ? "Name unchanged" : "Cancelled";
        return;
      }

      const auth = await odEnsureAuthedOrRedirect();
      if (!auth.ok) return;

      const playId = window.od_activePlayId || odGetCurrentPlayId();
      if (!playId) {
        alert("No play loaded.");
        return;
      }

      if (statusLeft) statusLeft.textContent = "Renaming…";

      const db = window.firebase.firestore();
      await db
        .collection("users")
        .doc(auth.user.uid)
        .collection("plays")
        .doc(playId)
        .set({ name: newName, updatedAt: new Date() }, { merge: true });

      const nameEl = document.getElementById("playName");
      if (nameEl) nameEl.value = newName;
      
      window.od_currentPlayName = newName;

      // ✅ Actualizar dropdown
      const playSelect = document.getElementById("editorPlaySelect");
      if (playSelect) {
        const opt = playSelect.querySelector(`option[value="${playId}"]`);
        if (opt) opt.textContent = newName;
        
        // ✅ Actualizar cache
        const cached = EditorCache.plays.find(p => p.id === playId);
        if (cached) cached.name = newName;
      }

      if (statusLeft) statusLeft.textContent = `Renamed: ${newName} ✓`;

    } catch (error) {
      console.error("[Rename]", error);
      if (statusLeft) statusLeft.textContent = "Rename failed";
      alert("Error renaming: " + (error?.message || error));
    }
  });
}

if (btnNewPlay && !btnNewPlay.dataset.wired) if (btnNewPlay && !btnNewPlay.dataset.wired) {
  btnNewPlay.dataset.wired = "1";
  
  btnNewPlay.addEventListener("click", async () => {
    try {
      // 1) Guardar play actual
      if (statusLeft) statusLeft.textContent = "Saving current…";
      await odSaveChanges({ silent: true });

      // 2) Pedir nombre
      const base = "Untitled play";
      const newName = (await odAskModal("New play name:", base) || "").trim();
      if (!newName) {
        if (statusLeft) statusLeft.textContent = "Cancelled";
        return;
      }

      // 3) Verificar auth
      const auth = await odEnsureAuthedOrRedirect();
      if (!auth.ok) return;

      if (statusLeft) statusLeft.textContent = "Creating…";

      // 4) Heredar contexto del play actual (puede estar vacío para plays viejas)
      const teamId = window.od_currentTeamId || currentTeamId || "";
      const seasonId = window.od_currentSeasonId || currentSeasonId || "";

      // 5) Crear play mínimo
      const now = new Date();
      const minimalPlay = {
        title: newName,
        notes: "",
        frames: [{ label: "Frame 1", desc: "", objects: [] }]
      };

      const payload = {
        name: newName,
        notes: "",
        teamId,
        seasonId,
        odplayV: ODPLAY_VERSION,
        odplayJson: JSON.stringify(minimalPlay),
        hasContent: false,
        status: "draft",
        createdAt: now,
        updatedAt: now
      };

      // 6) Crear en Firestore
      const db = window.firebase.firestore();
      const ref = db
        .collection("users")
        .doc(auth.user.uid)
        .collection("plays")
        .doc();

      await ref.set(payload);

      // 7) Cambiar de carril
      const newPlayId = ref.id;
      
      odSetCurrentPlayId(newPlayId);
      window.od_activePlayId = newPlayId;
      window.od_currentPlayName = newName;
      
      history.replaceState(
        null, 
        "", 
        `./editor.html?playId=${encodeURIComponent(newPlayId)}`
      );

// 8) Resetear UI
state.frames = [];

const f1 = newFrame("Frame 1");
const f2 = newFrame("Frame 2");
const f3 = newFrame("Frame 3");

snapshotFrame(f1);
snapshotFrame(f2);
snapshotFrame(f3);

state.frames.push(f1, f2, f3);
state.selectedObjectId = null;

const nameEl = document.getElementById("playName");
if (nameEl) nameEl.value = newName;

      // 9) ✅ Actualizar dropdown (ahora EditorCache existe)
      const playSelect = document.getElementById("editorPlaySelect");
      if (playSelect) {
        const opt = document.createElement("option");
        opt.value = newPlayId;
        opt.textContent = newName;
        playSelect.appendChild(opt);
        playSelect.value = newPlayId;
        
        // ✅ Actualizar cache
        EditorCache.plays.push({ id: newPlayId, name: newName });
      }


// 10) Render
renderAll();
selectFrame(f1.id);

      if (statusLeft) statusLeft.textContent = `Created: ${newName} ✓`;
      
    } catch (error) {
      console.error("[New Play]", error);
      if (statusLeft) statusLeft.textContent = "Error creating";
      alert("Error creating play: " + (error?.message || error));
    }
  });
}



// si venimos por URL, persistimos
if (playIdFromUrl) odSetCurrentPlayId(playIdFromUrl);

  if (zoomSel) zoomSel.value = String(Math.round(state.zoom * 100));
  setTool("select");
  ensureSelectArrowButton();
  ensureLineModePanel();


  try{ COURT_IMG = await loadImg(COURT_IMG_SRC); }
  catch{ }

  await preloadIcons();
  await preloadArrowheads();

  renderIconSidebar();
// ✅ Force Select as the true default mode


  setSelectedArrowhead(state.selectedArrowhead || "arrow.svg");

  if (OD_TEMPLATE_MODE) {
    await odBootTemplateAdminMode();
    return;
  }

  state.frames = [
    newFrame("Frame 1"),
    newFrame("Frame 2"),
    newFrame("Frame 3"),
    newFrame("Frame 4"),
  ];
  state.frames.forEach(f => snapshotFrame(f));

const mainEl = document.querySelector(".main");
mainEl?.classList.add("isLoading");

// refs
const teamSelect   = document.getElementById("editorTeamSelect");
const seasonSelect = document.getElementById("editorSeasonSelect");
const playSelect   = document.getElementById("editorPlaySelect");

// helper: asegura option en playSelect
function odEnsurePlayOption(playId){
  if (!playSelect || !playId) return;
  const has = !!playSelect.querySelector(`option[value="${playId}"]`);
  if (has) return;

  const opt = document.createElement("option");
  opt.value = playId;

  const nm =
    (window.od_currentPlayName || "").trim() ||
    (document.getElementById("playName")?.value || "").trim() ||
    "Untitled play";

  opt.textContent = nm;
  playSelect.appendChild(opt);
}

// helper: sync fuerte (team/season/plays + seleccionar play)
async function odSyncDropdownsToActivePlay(playId){
  // ids desde el play cargado
  currentTeamId   = window.od_currentTeamId   || "";
  currentSeasonId = window.od_currentSeasonId || "";
  currentPlayId   = playId || "";

  // Team visible
  if (teamSelect) teamSelect.value = currentTeamId || "";

  // Seasons (silent para no flicker)
  if (currentTeamId) await loadEditorSeasons(currentTeamId, { silent: true });
  if (seasonSelect) seasonSelect.value = currentSeasonId || "";

  // Plays (esto llena options)
  if (currentTeamId && currentSeasonId) await loadEditorPlays();

  // Asegurar option del play actual + seleccionar
  odEnsurePlayOption(playId);
  if (playSelect) playSelect.value = playId || "";
}

// 0) cargar play (frames + window.od_currentTeamId/SeasonId/PlayName + window.od_activePlayId)
od_isSwitchingContext = true;
try {
  await odTryLoadPlayFromOrganizer();
} finally {
  od_isSwitchingContext = false;
}

// 1) auth + db
const auth = await odEnsureAuthedOrRedirect();
if (!auth.ok) return;

const user = auth.user;
window.currentUid = user.uid;
window.dbCompat = window.firebase.firestore();

// 2) cargar teams (para que existan options de team)
await loadEditorTeams(user.uid);

// 3) SYNC fuerte (al entrar desde organizer)
od_isSwitchingContext = true;
try {
  const activePlayId = window.od_activePlayId || playId; // playId es el del boot
  await odSyncDropdownsToActivePlay(activePlayId);
} finally {
  od_isSwitchingContext = false;
}

// 4) listeners UNA sola vez
if (teamSelect && !teamSelect.dataset.wired) {
  teamSelect.dataset.wired = "1";
  teamSelect.addEventListener("change", async (e) => {
    od_isSwitchingContext = true;
    try {
      currentTeamId = (e.target.value || "").trim();
      currentSeasonId = "";
      currentPlayId = "";

      window.od_currentTeamId = currentTeamId;
      window.od_currentSeasonId = "";

      if (seasonSelect) seasonSelect.innerHTML = `<option value="">Season</option>`;
      if (playSelect)   playSelect.innerHTML   = `<option value="">Play</option>`;

      if (!currentTeamId) return;

      await loadEditorSeasons(currentTeamId);
await loadEditorSeasons(currentTeamId); // ya llena options

// ✅ auto-seleccionar una Season (primera disponible)
if (seasonSelect) {
  // opción #0 es "Season" (vacía). La primera real suele ser options[1]
  const firstReal = seasonSelect.options?.[1]?.value || "";

  if (firstReal) {
    seasonSelect.value = firstReal;

    // mantener estado coherente con tu listener de Season
    currentSeasonId = firstReal;
    window.od_currentSeasonId = firstReal;

    // reset plays + cargar plays para team+season
    if (playSelect) playSelect.innerHTML = `<option value="">Play</option>`;
    await loadEditorPlays();
  }
}

    // acá SÍ resetea, es correcto
    } finally {
      od_isSwitchingContext = false;
    }
  });
}

if (seasonSelect && !seasonSelect.dataset.wired) {
  seasonSelect.dataset.wired = "1";
  seasonSelect.addEventListener("change", async (e) => {
    od_isSwitchingContext = true;
    try {
      currentSeasonId = (e.target.value || "").trim();
      currentPlayId = "";

      window.od_currentSeasonId = currentSeasonId;

      if (playSelect) playSelect.innerHTML = `<option value="">Play</option>`;
      if (!currentSeasonId) return;

      await loadEditorPlays(); // llena options de plays del team+season actual
    } finally {
      od_isSwitchingContext = false;
    }
  });
}

if (playSelect && !playSelect.dataset.wired) {
  playSelect.dataset.wired = "1";
  playSelect.addEventListener("change", async (e) => {
    od_isSwitchingContext = true;
    try {
      const nextPlayId = (e.target.value || "").trim();
      if (!nextPlayId) return;

      // cambiar carril
      currentPlayId = nextPlayId;
      odSetCurrentPlayId(nextPlayId);
      window.history.replaceState(null, "", `./editor.html?playId=${encodeURIComponent(nextPlayId)}`);

      // cargar play
      await odTryLoadPlayFromOrganizer();
const teamId = window.od_currentTeamId || "";
const seasonId = window.od_currentSeasonId || "";

currentTeamId = teamId;
currentSeasonId = seasonId;

// team value (sin reset)
if (teamSelect) teamSelect.value = teamId;

// seasons solo si cambió team
await loadEditorSeasons(teamId, { silent: true });
if (seasonSelect) seasonSelect.value = seasonId;

// plays solo si cambió team/season
await loadEditorPlays();

// asegurar play option + seleccionar
if (playSelect && nextPlayId) {
  if (!playSelect.querySelector(`option[value="${nextPlayId}"]`)) {
    const opt = document.createElement("option");
    opt.value = nextPlayId;
    opt.textContent = window.od_currentPlayName || "Untitled play";
    playSelect.appendChild(opt);
  }
  playSelect.value = nextPlayId;
}

      // SYNC fuerte post-load (y sin flicker)
      await odSyncDropdownsToActivePlay(nextPlayId);
    } finally {
      od_isSwitchingContext = false;
    }
  });
}

// 5) render una sola vez
renderAll();
odEnsureTemplatesMenu();
const animationRequested = openRequestedAnimation(window.currentUid);
if (!animationRequested) showAnimationAnnouncement({
  surface: "editor", uid: window.currentUid,
  onTry: () => { const button = document.getElementById("odAnimateBtn"); button?.focus(); button?.click(); }
});

requestAnimationFrame(() => {
  mainEl?.classList.remove("isLoading");
});

// Tour de onboarding — solo desktop, solo primera vez
if (!animationRequested && !window.matchMedia("(max-width:900px)").matches) {
  setTimeout(() => startTour(getEditorTourSteps(), 'od_tour_editor_v1'), 900);
}




    // Wire export button if exists
  const exportPdfBtn = document.querySelector("#exportPdfBtn");
  if (exportPdfBtn) {
    exportPdfBtn.addEventListener("click", (e)=>{
      e.preventDefault();
      e.stopPropagation();
      exportTitleAndFramesToPDF();
    });
  }

(function ensureFirebaseInit(){
  if (!window.firebase) return;
  if (firebase.apps && firebase.apps.length) return;

  const firebaseConfig = window.__OD_FIREBASE_CONFIG__ || null;
  if (!firebaseConfig) return;

  firebase.initializeApp(firebaseConfig);

  if (firebase.appCheck) {
    firebase.appCheck().activate("6LceeogsAAAAAMVzaOl90c2Tix-VoZA1mN6oR6p6", true);
  }
})();






// Modal overlay (your current HTML)
const overlay   = document.getElementById("odModalOverlay");
const closeBtn  = document.getElementById("odModalClose");
const cancelBtn = document.getElementById("odModalCancel");
const confirmBtn = document.getElementById("odModalAdd");
const saveAsNewBtn = document.getElementById("saveAsNewBtn");

if (!saveAsNewBtn) console.warn("");


// Typeahead inputs + suggestion boxes (must exist in your modal HTML)
const teamInput   = document.getElementById("odTeamInput");
const teamSuggest = document.getElementById("odTeamSuggest");
const seasonInput   = document.getElementById("odSeasonInput");
const seasonSuggest = document.getElementById("odSeasonSuggest");

const newTeamBtn   = document.getElementById("odNewTeamBtn");
const newSeasonBtn = document.getElementById("odNewSeasonBtn");

const hintEl = document.getElementById("odModalHint");
const playNameInput = document.getElementById("playName");

function setHint(msg){
  if (hintEl) hintEl.textContent = msg || "";
}

function openModal(){
  if (!overlay) return;
  overlay.removeAttribute("hidden");
  overlay.style.display = ""; // undo inline display:none
  overlay.classList.add("show");
  overlay.setAttribute("aria-hidden", "false");
}

function closeModal(){
  if (!overlay) return;
  overlay.classList.remove("show");
  overlay.setAttribute("aria-hidden", "true");
  overlay.setAttribute("hidden", "");
  overlay.style.display = "none";
  setHint("");
}

// ---- local modal state ----
let selectedTeam = null;   // {id|null, name}
let selectedSeason = null; // {id|null, name}
let cachedTeams = [];      // [{id,name,nameLower}]
let cachedSeasons = [];    // seasons del team seleccionado

function norm(s){
  return (s || "").trim().toLowerCase();
}

function showSuggest(box, items, onPick){
  box.innerHTML = "";
  if (!items.length){
    const div = document.createElement("div");
    div.className = "odSugItem odSugMuted";
    div.textContent = "No matches";
    box.appendChild(div);
    box.classList.remove("hidden");
    return;
  }

  for (const it of items){
    const div = document.createElement("div");
    div.className = "odSugItem";
    div.textContent = it.name;
    div.addEventListener("click", ()=> onPick(it));
    box.appendChild(div);
  }
  box.classList.remove("hidden");
}

function hideSuggest(box){
  box.classList.add("hidden");
  box.innerHTML = "";
}

async function loadTeams(db, uid){
  try{
    const snap = await db.collection("users").doc(uid).collection("teams").get();
    cachedTeams = snap.docs.map(d => {
      const data = d.data() || {};
      const name = (data.name || "").trim();
      return { id:d.id, name, nameLower: norm(name) };
    });

    
  } catch (err){
    
    cachedTeams = [];
    setHint("Could not load teams (check auth/rules/config).");
  }
}
async function loadEditorSeasons(teamId, opts = {}){
  const select = document.getElementById("editorSeasonSelect");
  if (!select || !teamId) return;

  // ✅ Si ya cargamos seasons de ESTE team, skip
  if (EditorCache.loadedTeamId === teamId) {
    return;
  }

  const currentValue = opts.silent ? select.value : "";
  select.innerHTML = `<option value="">Season</option>`;

  EditorCache.loadedTeamId = teamId;

  const db  = window.dbCompat || window.firebase.firestore();
  const uid = window.currentUid;

    const snap = await db
    .collection("users").doc(uid)
    .collection("teams").doc(teamId)
    .collection("seasons")
    .orderBy("createdAt", "asc")
    .get();

  snap.forEach(d => {
    const opt = document.createElement("option");
    opt.value = d.id;
    opt.textContent = (d.data()?.name || "").trim();
    select.appendChild(opt);
  });

  if (opts.silent && currentValue) select.value = currentValue;
}




async function loadEditorPlays() {
  const select = document.getElementById("editorPlaySelect");
  if (!select) return;

  if (!currentTeamId || !currentSeasonId) {
    select.innerHTML = `<option value="">Play</option>`;
    EditorCache.loadedSeasonId = null;
    EditorCache.plays = [];
    return;
  }

  // ✅ Cache key compuesto
  const cacheKey = `${currentTeamId}::${currentSeasonId}`;
  if (EditorCache.loadedSeasonId === cacheKey) {
    return;
  }

  const currentValue = select.value;
  select.innerHTML = `<option value="">Play</option>`;
  EditorCache.loadedSeasonId = cacheKey;
  EditorCache.plays = [];

  const db = window.dbCompat || window.firebase.firestore();
  const uid = window.currentUid;

  const snap = await db
    .collection("users").doc(uid)
    .collection("plays")
    .where("teamId", "==", currentTeamId)
    .where("seasonId", "==", currentSeasonId)
    .get();

  snap.forEach(d => {
    const playData = { id: d.id, name: d.data()?.name || "" };
    EditorCache.plays.push(playData);
    
    const opt = document.createElement("option");
    opt.value = d.id;
    opt.textContent = playData.name.trim();
    select.appendChild(opt);
  });

  if (currentValue && select.querySelector(`option[value="${currentValue}"]`)) {
    select.value = currentValue;
  }

}




async function loadSeasons(db, uid, teamId){
  try{
    const snap = await db.collection("users").doc(uid)
      .collection("teams").doc(teamId)
      .collection("seasons").get();

    cachedSeasons = snap.docs.map(d => {
      const data = d.data() || {};
      const name = (data.name || "").trim();
      return { id:d.id, name, nameLower: norm(name) };
    });

  } catch (err){
    cachedSeasons = [];
    setHint("Could not load seasons (check rules).");
  }
}

const modalOk =
  saveAsNewBtn && overlay && confirmBtn &&
  teamInput && teamSuggest && seasonInput && seasonSuggest &&
  newTeamBtn && newSeasonBtn;

// ===== DEBUG: verify all modal elements exist =====

// If firebase not available, disable button and avoid breaking anything
if (saveAsNewBtn && !window.firebase){
  saveAsNewBtn.disabled = true;
  saveAsNewBtn.title = "Firebase not loaded (missing firebase compat scripts)";
}

// ✅ Save As New wiring (ONLY if button exists)
else {
}

// ✅ Mini modal listeners (safe even if modal missing)
const btnCancel = document.getElementById("odSaveAsNewCancel");
const btnConfirm = document.getElementById("odSaveAsNewConfirm");
const nameInput = document.getElementById("odSaveAsNewName");

if (btnCancel && !btnCancel.dataset.wired){
  btnCancel.dataset.wired = "1";
  btnCancel.addEventListener("click", odCloseSaveAsNewModal);
}
if (btnConfirm && !btnConfirm.dataset.wired){
  btnConfirm.dataset.wired = "1";
  btnConfirm.addEventListener("click", odCommitSaveAsNew);
}
if (nameInput && !nameInput.dataset.wired){
  nameInput.dataset.wired = "1";
  nameInput.addEventListener("keydown", (e)=>{
    if (e.key === "Enter") odCommitSaveAsNew();
    if (e.key === "Escape") odCloseSaveAsNewModal();
  });
}

  



  // FINAL ADD: commit Team (if new) + Season (if new) + Play (ALWAYS CREATE NEW)
  // FINAL ADD: commit Team (if new) + Season (if new) + Play (ALWAYS CREATE NEW)


}
function odCloseSaveAsNewModal(){
  const overlay = document.getElementById("odSaveAsNewOverlay");
  if (!overlay) return;

  overlay.setAttribute("aria-hidden", "true");
  overlay.hidden = true;
  overlay.style.display = "none";
}



// safer boot
window.addEventListener("DOMContentLoaded", boot);
